import type { TranslationKey } from './types';

export const ru: Record<TranslationKey, string> = {
    // Общие
    'common.login': 'Войти',
    'common.logout': 'Выйти',
    'common.save': 'Сохранить',
    'common.saving': 'Сохранение…',
    'common.saved': 'Сохранено',
    'common.cancel': 'Отмена',
    'common.delete': 'Удалить',
    'common.deleting': 'Удаление…',
    'common.edit': 'Изменить',
    'common.loading': 'Загрузка…',
    'common.error': 'Ошибка',
    'common.back': 'Назад',
    'common.next': 'Следующий',
    'common.finish': 'Завершить',
    'common.search': 'Поиск',
    'common.copy': 'Копировать',
    'common.copied': 'Скопировано',
    'common.open': 'Открыть',
    'common.confirm': 'Подтвердить',
    'common.yes': 'Да',
    'common.no': 'Нет',
    'common.close': 'Закрыть',
    'common.retry': 'Повторить',
    'common.language': 'Язык',

    'player.games_title': 'Игры',
    'player.open_stats': '📊 Статистика игрока',
    'player.overlay_show': '📺 В оверлей OBS',
    'player.overlay_show_hint': 'Показать карточку в OBS-оверлее на 7 секунд в выбранном здесь режиме (ссылка оверлея — в «Режиме стримера»).',
    'player.overlay_show_done': '✓ Показано в оверлее',
    'player.overlay_show_error': 'Не удалось вывести в оверлей:',
    'player.overlay_show_no_obs': 'Показано, но источник оверлея в OBS не подключён — обновите его (ссылка — в «Режиме стримера»).',
    'player.games_all': 'Все игры',
    'player.games_empty': 'Игрок ещё не участвовал в играх',
    'player.games_total': 'Всего игр',
    'player.games_wins': 'Побед',
    'player.games_winrate': 'Винрейт',
    'player.games_favorite_race': 'Любимая раса',
    'player.games_favorite_format': 'Любимый формат',
    'player.games_races_title': 'Статистика по расам',
    'player.games_games_word': 'игр',
    'player.games_wins_word': 'побед',
    'player.games_result_win': 'Победа',
    'player.games_load_error': 'Не удалось загрузить игры',
    'player.games_show_all': 'Показать все',
    'player.games_hide_all': 'Скрыть',
    'player.game_details_title': 'Информация об игре',
    'player.game_details_duration': 'Длительность',
    'player.game_details_notes': 'Заметки',
    'player.host_title': 'Ведущий игр',
    'player.host_games_total': 'Проведено игр',
    'player.host_total_players': 'Всего участников',
    'player.host_avg_players': 'В среднем за игру',
    'player.host_last_game': 'Последняя игра',
    'player.host_games_empty': 'Ведущий ещё не провёл игр',
    'player.host_load_error': 'Не удалось загрузить статистику ведущего',
    'player.host_top_maps': 'Топ карт',
    'player.host_top_mods': 'Топ модов',
    'player.host_top_players': 'Топ игроков',
    'player.games_tops_title': 'Статистика по играм',
    'player.games_top_maps': 'Топ карт',
    'player.games_top_mods': 'Топ модов',
    'player.games_top_teammates': 'Топ тиммейтов',
    'player.links_title': 'Ссылки',
    'player.link_live': 'в эфире',

    'games.title': 'Игры',
    'games.search_placeholder': 'Поиск по игроку, карте, хосту…',
    'games.add_button': '+ Добавить игру',
    'games.no_games': 'Пока нет игр',
    'games.nothing_found': 'Ничего не найдено',
    'games.load_error': 'Не удалось загрузить игры: ',
    'games.load_more': 'Показать более ранние игры',
    'games.loading_more': 'Загрузка…',
    'games.host_label': 'Проводил',
    'games.added_by': 'добавил',
    'games.edited_at': 'изменено',
    'games.created_at': 'создано',
    'games.time_ago_just_now': 'только что',
    'games.time_ago_minutes': '{n} мин назад',
    'games.time_ago_hours': '{n} ч назад',
    'games.time_ago_days': '{n} дн назад',
    'games.minutes_short': 'мин',
    'games.new_badge': 'новое',
    'games.new_badge_hint': 'Игра появилась с вашего прошлого визита',
    'games.new_banner_title': 'Новых игр с прошлого визита: {n}',
    'games.new_banner_hint': 'Поставьте реакции и отметьте, кто запомнился — это пара кликов',
    'games.new_banner_hint_anon': 'Войдите, чтобы оценить игры',
    'games.new_banner_dismiss': 'Скрыть',

    'games.form_title': 'Новая игра',
    'games.field_date': 'Дата и время',
    'games.field_format': 'Формат',
    'games.field_host': 'Проводящий',
    'games.field_map': 'Карта',
    'games.field_mod': 'Мод',
    'games.lobby_settings': 'Настройки лобби',
    'games.field_duration': 'Длительность (мин, опционально)',
    'games.field_players': 'Участники',
    'games.field_notes': 'Заметки (опционально)',
    'games.add_player': '+ Добавить игрока',
    'games.auto_places': 'Расставить места',
    'games.auto_places_hint': 'Проставить места по порядку игроков в списке (верхний — 1-е место)',
    'games.remove_player': 'Удалить',
    'games.move_up': 'Переместить выше',
    'games.move_down': 'Переместить ниже',
    'games.winner_label': 'Победитель',
    'games.select_placeholder': '— выберите —',
    'games.no_mod': '— без мода —',
    'games.player_placeholder': 'Имя игрока…',
    'games.error_no_date': 'Укажите дату и время',
    'games.error_no_refs': 'Заполните все обязательные поля',
    'games.error_no_players': 'Добавьте хотя бы одного участника',
    'games.error_no_winner': 'Отметьте хотя бы одного победителя',
    'games.save_error': 'Не удалось сохранить игру: ',
    'games.confirm_close': 'Закрыть форму? Несохранённые изменения будут потеряны.',
    'games.player_not_found': 'Игрок не найден',
    'games.error_duplicate_player': 'Один игрок выбран дважды',
    'games.form_title_edit': 'Редактирование игры',
    'games.edit_game': 'Редактировать',
    'games.delete_game': 'Удалить',
    'games.duplicate_settings': 'Добавить новую игру, скопировав настройки из этой',
    'games.delete_confirm': 'Удалить игру от {date} (победители: {winners})?',
    'games.delete_error': 'Не удалось удалить: ',
    'games.load_one_error': 'Не удалось загрузить игру: ',
    'games.field_place': 'Место',
    'games.error_duplicate_place': 'У двух игроков одинаковое место',
    'games.error_missing_places': 'Не у всех игроков указано место',
    'games.error_player_not_selected': 'Выберите игрока из списка: {names}',
    'games.players_hint': 'Отметьте победителя галочкой. Остальным укажите место (2-е, 3-е, …) — места не должны повторяться.',
    'games.placement_hint_solo': 'Игроки расставляются по общему счёту, не считая победителя.',
    'games.placement_hint_team': 'Игроки расставляются по общему счёту независимо от того, победители или нет.',

    // Шапка
    'topbar.league': 'SC2 FFA ЛИГА',
    'topbar.database': '// БАЗА ИГРОКОВ',
    'topbar.streamer_mode': 'Режим стримера',
    'topbar.admin': 'Админ',
    'topbar.guest': 'Вы не авторизованы',
    'topbar.role_admin': 'ADMIN',
    'topbar.role_moderator': 'MOD',
    'topbar.role_ghost': 'GHOST',

    // Уведомления
    'notif.delete': 'Удалить уведомление',
    'notif.title': 'Уведомления',
    'notif.mark_all': 'Прочитать все',
    'notif.empty': 'Пока нет уведомлений',
    'notif.load_error': 'Не удалось загрузить уведомления',
    'notif.anonymous': 'Пользователь',
    'notif.rating_new': '{name} поставил вам оценку',
    'notif.rating_changed': '{name} изменил вашу оценку',
    'notif.player': 'Игрок: {name}',
    'notif.race': 'раса {race}',
    'notif.changed': 'изменено: {fields}',
    'notif.field.race': 'раса',
    'notif.field.tier': 'тир',
    'notif.role_granted': 'Вам выдана роль {role}',
    'notif.role_revoked': 'У вас снята роль {role}',
    'notif.role_moderator': 'модератор',
    'notif.role_admin': 'администратор',
    'notif.role_ghost': 'ghost',
    'notif.player_linked': 'Ваш профиль привязан к игроку',
    'notif.by': 'от {name}',
    'notif.recap_title': 'С прошлого визита: что нового',
    'notif.recap_meta': 'Новых игр: {n}',

    'nav.players': 'Игроки',
    'nav.games': 'Игры',
    'nav.maps': 'Карты',
    'nav.mods': 'Моды',
    'nav.stats': 'Статистика',

    // Раздел «Карты»
    'maps.title': 'Карты',
    'maps.search_placeholder': 'Поиск карты…',
    'maps.filter_all': 'Все',
    'maps.filter_type': 'Тип карты',
    'maps.filter_players': 'Игроков',
    'maps.filter_formats': 'Формат команд',
    'maps.filter_author': 'Автор',
    'maps.filter_all_authors': 'Все авторы',
    'maps.filter_list': 'Список',
    'maps.filter_all_lists': 'Все списки',
    'maps.author': 'Автор: {name}',
    'maps.link': 'Ссылка',
    'maps.copy_name_hint': 'Нажмите, чтобы скопировать название',
    'maps.copy_link': 'Скопировать ссылку',
    'maps.copied': 'Скопировано!',
    'maps.author_not_found': 'Автор не найден',
    'maps.players': 'Игроков: {n}',
    'maps.like': 'Нравится',
    'maps.dislike': 'Не нравится',
    'maps.hover_hint': 'Наведите, чтобы увеличить',
    'maps.empty': 'Карты не найдены',
    'maps.error': 'Не удалось загрузить карты',
    'maps.add_button': 'Добавить карту',
    'maps.form_title': 'Новая карта',
    'maps.form_title_edit': 'Редактирование карты',
    'maps.field_name': 'Название',
    'maps.field_alt': 'Альт. название (локализация)',
    'maps.field_players': 'Игроков',
    'maps.field_author': 'Автор',
    'maps.field_link': 'Ссылка',
    'maps.field_types': 'Типы карты',
    'maps.field_formats': 'Формат командных',
    'maps.field_image': 'Картинка',
    'maps.field_unbalanced': 'Дисбалансная карта',
    'maps.unbalanced_badge': 'Дисбалансная',
    'maps.unbalanced_hint': 'Карта помечена модератором как несбалансированная',
    'maps.name_required': 'Укажите название карты',
    'maps.link_loading': 'Загружаю данные карты по ссылке…',
    'maps.link_filled': 'Пустые поля заполнены по ссылке — проверьте',
    'maps.link_not_found': 'По ссылке ничего не нашлось — заполните вручную',
    'maps.new_error': 'Не удалось создать карту: ',
    'maps.save_error': 'Не удалось сохранить карту: ',
    'maps.edit_hint': 'Нажмите, чтобы изменить',

    // Раздел «Моды»
    'mods.title': 'Моды',
    'mods.search_placeholder': 'Поиск мода…',
    'mods.filter_author': 'Автор',
    'mods.filter_all_authors': 'Все авторы',
    'mods.author': 'Автор: {name}',
    'mods.like': 'Нравится',
    'mods.dislike': 'Не нравится',
    'mods.empty': 'Моды не найдены',
    'mods.error': 'Не удалось загрузить моды',
    'mods.add_button': 'Добавить мод',
    'mods.edit_hint': 'Нажмите, чтобы изменить',
    'mods.form_title': 'Новый мод',
    'mods.form_title_edit': 'Редактирование мода',
    'mods.field_name': 'Название',
    'mods.field_author': 'Автор',
    'mods.field_description': 'Описание',
    'mods.field_description_placeholder': 'Коротко о моде',
    'mods.name_required': 'Укажите название мода',
    'mods.new_error': 'Не удалось создать мод: ',
    'mods.save_error': 'Не удалось сохранить мод: ',
    'mods.autosave_hint': 'Изменения сохраняются автоматически по мере ввода — отдельная кнопка «Сохранить» не нужна.',
    'mods.autosave_pending': 'Не сохранено',
    'mods.autosave_error': 'Не удалось сохранить',
    'mods.unsaved_confirm': 'Изменения ещё не сохранены. Закрыть форму без сохранения?',
    'mods.done': 'Готово',
    'mods.settings_title': 'Настройки',
    'mods.settings_hint': 'Параметры использует рандомизатор настроек мода. Вложенные параметры (↳) появляются только при выбранном значении параметра-переключателя.',
    'mods.settings_empty': 'Параметров пока нет',
    'mods.settings_count': 'Параметров: {n}',
    'mods.settings_save_error': 'Мод сохранён, но настройки не сохранились: ',
    'mods.add_param': '+ Параметр',
    'mods.param_name_placeholder': 'Параметр',
    'mods.param_values_placeholder': 'Значения через запятую',
    'mods.param_default_placeholder': 'По умолчанию',
    'mods.param_default_hint': 'Значение по умолчанию (должно входить в список значений)',
    'mods.param_default_short': 'по умолч.: {value}',
    'mods.param_randomize': 'Рандом',
    'mods.param_randomize_hint': 'Рандомизировать параметр по умолчанию',
    'mods.param_fixed_short': 'не рандом.',
    'mods.param_fixed_hint': 'Параметр не рандомизируется по умолчанию',
    'mods.games_count': 'Игр: {n}',
    'mods.games_count_hint': 'Сколько игр сыграно с этим модом',
    'mods.presets_title': 'Пресеты настроек',
    'mods.presets_hint': 'Сохранённые комбинации значений параметров.',
    'mods.presets_empty': 'Пресетов пока нет',
    'mods.presets_label': 'Пресеты:',
    'mods.presets_no_params': 'Сначала добавьте параметры со значениями',
    'mods.preset_name_placeholder': 'Название пресета',
    'mods.add_preset': '+ Пресет',
    'mods.delete_preset': 'Удалить пресет',
    'mods.preset_no_values': 'Значения не заданы',
    'mods.delete_param': 'Удалить параметр',
    'mods.param_depends_label': 'Ветвление',
    'mods.param_depends_always': 'нет — активен всегда',
    'mods.param_depends_hint': 'Ветвление: параметр появится, только если у выбранного параметра будет одно из отмеченных значений',
    'mods.param_depends_short': 'при {param} = {values}',
    'mods.param_depends_values_hint': 'Отметьте значения, при которых параметр активен',
    'mods.param_add_hint': 'Добавить параметр верхнего уровня',
    'mods.import_replay': '⤓ Из реплея',
    'mods.import_replay_hint': 'Взять опции лобби из реплея, сыгранного на этом моде (файл мода скачается с серверов Blizzard)',
    'mods.import_replay_loading': 'Загрузка…',
    'mods.import_replay_error': 'Не удалось прочитать реплей: ',
    'mods.import_replay_none': 'В реплее нет мода с опциями лобби (или файлы мода не скачались)',
    'mods.import_replay_pick': 'Взять опции лобби из «{name}»?',
    'mods.import_replay_replace': 'Заменить параметры опциями из «{name}»?\n\n{params}\n\nСвои названия и ветвления придётся поправить заново.',
    'mods.param_field_values': 'Значения (через запятую)',
    'mods.param_field_default': 'По умолчанию',
    'mods.param_branch_count': 'ветвлений: {n}',
    'mods.param_branch_count_hint': 'От этого параметра зависят другие (вложенные) параметры',
    'mods.param_branch_add': '↳ вложенный',
    'mods.param_branch_add_hint': 'Добавить параметр, активный при значениях этого',
    'mods.param_branch_values_label': 'Активен при значениях:',
    'mods.param_branch_warn': 'Не отмечено ни одного значения — ветвление не сохранится',
    'mods.exclusions_button': 'Исключения',
    'mods.exclusions_button_hint': 'Какие параметры и значения не должны выпадать при рандомизации',
    'mods.exclusions_button_active': 'Исключено: {n}. Клик — настроить',
    'mods.exclusions_button_none': 'Ничего не исключено — все параметры участвуют в розыгрыше. Клик — настроить',
    'mods.exclusions_summary_params': 'выключено параметров: {n}',
    'mods.exclusions_summary_values': 'исключено значений: {n} из {total}',
    'mods.exclusions_title': 'Исключения из рандомизации',
    'mods.exclusions_hint': 'Мод «{name}». Отметьте параметры целиком или отдельные значения, которые не должны выпадать в рандомизаторе настроек. Настройка общая — её увидят все.',
    'mods.exclusions_hint_local': 'Мод «{name}». Отметьте параметры целиком или отдельные значения, которые не должны выпадать в рандомизаторе. Изменения сохраняются только в этом браузере, «Сбросить на умолчания» вернёт общие настройки.',
    'mods.exclusions_disable_hint': 'Убрать параметр из рандомизации целиком',
    'mods.exclusions_disabled': 'не рандомизируется',
    'mods.exclusions_excluded': 'исключено: {n} из {total}',
    'mods.exclusions_value_hint': 'Клик — исключить значение из розыгрыша',
    'mods.exclusions_value_back_hint': 'Клик — вернуть значение в розыгрыш',
    'mods.exclusions_last_value': 'Нельзя исключить последнее значение — рандомизатору нужен выбор',
    'mods.exclusions_reset': 'Сбросить на умолчания',
    'mods.exclusions_save_error': 'Не удалось сохранить исключения',
    'mods.param_disabled_short': 'исключён',
    'mods.param_excluded_short': 'исключено: {n}',

    // Экран авторизации
    'auth.login_title': 'Вход',
    'auth.signup_title': 'Регистрация',
    'auth.login_loading': 'Входим…',
    'auth.signup_loading': 'Создаём…',
    'auth.identifier_placeholder': 'Email или никнейм',
    'auth.password_placeholder': 'Пароль',
    'auth.password_placeholder_signup': 'Пароль (мин. 6)',
    'auth.show_password': 'Показать пароль',
    'auth.hide_password': 'Скрыть пароль',
    'auth.username_placeholder': 'Никнейм (3-32 символа)',
    'auth.email_placeholder': 'Email',
    'auth.no_account': 'Нет аккаунта?',
    'auth.have_account': 'Уже есть аккаунт?',
    'auth.signup_link': 'Зарегистрироваться',
    'auth.login_link': 'Войти',
    'auth.error_login': 'Ошибка входа: ',
    'auth.error_signup': 'Ошибка регистрации: ',
    'auth.error_invalid_credentials': 'Неверный email/никнейм или пароль.',
    'auth.error_email_not_confirmed': 'Email не подтверждён. Проверьте почту и перейдите по ссылке из письма, затем войдите.',
    'auth.error_account_banned': 'Аккаунт заблокирован.',
    'auth.error_username_taken': 'Этот никнейм уже занят.',
    'auth.error_username_short': 'Никнейм должен быть не короче 3 символов',
    'auth.error_email_invalid': 'Введите корректный email',
    'auth.error_password_short': 'Пароль должен быть не короче 6 символов',
    'auth.error_identifier_required': 'Введите email или никнейм',
    'auth.error_password_required': 'Введите пароль',
    'auth.account_created_confirm': 'Аккаунт создан. Проверьте почту, чтобы подтвердить email, затем войдите.',
    'auth.account_created': 'Аккаунт создан',
    'auth.captcha_required': 'Пожалуйста, подтвердите, что вы не робот',
    'auth.email_note_title': 'Совет по почте',
    'auth.email_note_text': 'Письма для подтверждения могут не доходить на российские почтовые сервисы (Mail.ru, Yandex и т.п.). Рекомендуем регистрироваться на зарубежную почту — например, Gmail.',
    'auth.forgot_link': 'Забыли пароль?',
    'auth.forgot_title': 'Сброс пароля',
    'auth.forgot_hint': 'Укажите email или никнейм — мы отправим ссылку для смены пароля.',
    'auth.forgot_button': 'Отправить ссылку',
    'auth.forgot_sent': 'Если аккаунт существует, письмо со ссылкой для сброса пароля отправлено. Проверьте почту.',
    'auth.reset_title': 'Новый пароль',
    'auth.reset_button': 'Сохранить пароль',
    'auth.password_repeat_placeholder': 'Повторите пароль',
    'auth.error_password_mismatch': 'Пароли не совпадают',
    'auth.reset_invalid': 'Ссылка недействительна или устарела.',
    'auth.reset_success': 'Пароль изменён. Теперь можно войти.',
    'auth.link_expired': 'Ссылка из письма устарела или уже была использована. Запросите новую — «Забыли пароль?» на этой странице.',
    'auth.link_invalid': 'Ссылка недействительна. Запросите новую ссылку ещё раз.',

    // Список игроков
    'who.followers': 'Подписчики',
    'who.likes': 'Лайкнули',
    'who.dislikes': 'Дизлайкнули',
    'who.none': 'пока никого',
    'players.title': 'Игроки',
    'players.search_placeholder': 'Поиск по имени или aka…',
    'players.view_table': 'Таблица',
    'players.view_cards': 'Карточки',
    'players.view_tierlist': 'Тирлист',
    'players.tierlist_no_tier': 'Без тира',
    'players.tierlist_rater_label': 'Тирлист игрока',
    'players.tierlist_rater_placeholder': 'Выбрать игрока…',
    'players.tierlist_rater_empty': 'Этот игрок ещё не выставлял тиры',
    'players.tierlist_rater_error': 'Не удалось загрузить тирлист игрока',
    'players.add_placeholder': 'Имя нового игрока',
    'players.add_button': 'Добавить',
    'players.review_all': 'Оценить всех',
    'players.no_players': 'Пока нет игроков',
    'players.nothing_found': 'Ничего не найдено',
    'players.loading': 'Загрузка…',
    'players.load_error': 'Не удалось загрузить игроков: ',
    'players.delete_confirm': 'Удалить игрока "{name}"?\n\nВсе его оценки ({count}) будут удалены безвозвратно.',
    'players.delete_error': 'Не удалось удалить: ',
    'players.sort_by': 'Сортировка',
    'players.sort_asc': 'По возрастанию',
    'players.sort_desc': 'По убыванию',

    'players.col.elo': 'MMR',

    'nav.leaderboard': 'Рейтинг',

    'nav.tools': 'Инструменты',
    'tools.title': 'Инструменты',
    'tools.hero_eyebrow': 'FFA League · Арсенал',
    'tools.hero_desc':
        'Всё для подготовки и показа матча: розыгрыш карты и мода, прогноз победителя, сценарий встречи и оверлей для стрима.',
    'tools.open': 'Открыть',
    'tools.tag_match': 'Сценарий',
    'tools.tag_predict': 'Аналитика',
    'tools.tag_random': 'Рандом',
    'tools.tag_streamer': 'Стрим',
    'tools.streamer_desc':
        'Оверлей для OBS: карточки игроков, настройки показа и ссылка на оверлей.',
    'tools.match_title': 'Менеджер матча',
    'tools.match_desc':
        'Интерактивный сценарий матча: разыграть карту и мод, собрать участников, посчитать прогноз, запустить режим стримера с закреплёнными игроками и добавить игру в список.',
    'tools.match_stage_map': 'Карта и режим',
    'tools.match_stage_players': 'Участники',
    'tools.match_stage_predict': 'Прогноз победителя',
    'tools.match_stage_stream': 'Режим стримера',
    'tools.match_skip': 'Пропустить этап',
    'tools.match_skip_back': 'Вернуть розыгрыш',
    'tools.match_skipped': 'Этап пропущен — карта и мод не учитываются.',
    'tools.match_no_pick': 'Нажмите «Крутить!», чтобы разыграть карту и мод.',
    'tools.match_open_streamer': 'Открыть режим стримера',
    'tools.match_streamer_hint':
        '{n} игроков будут закреплены сверху списка в режиме стримера — карточки под рукой.',
    'tools.match_streamer_no_players':
        'Добавьте участников — они будут закреплены сверху списка в режиме стримера.',
    'tools.match_preset': 'Пресет',
    'tools.match_preset_all': '— все карты и моды —',
    'tools.match_preset_maps': 'Карты из пресета',
    'tools.match_preset_mods': 'Моды из пресета',
    'tools.match_preset_empty': 'В пресете нет карт или модов.',
    'tools.match_preset_show': 'Показать набор пресета',
    'tools.match_preset_hide': 'Скрыть набор пресета',
    'tools.match_preset_dynamic': 'По типу и игрокам',
    'tools.match_preset_any_count': 'любое число игроков',
    'tools.match_reset': '⟲ Сбросить',
    'tools.match_reset_confirm': 'Сбросить участников, розыгрыш, пул карт/модов и пресет?',
    'tools.match_stage_add_game': 'Добавить игру',
    'tools.match_stage_pool': 'Пул матча',
    'tools.match_pool_hint':
        'Клик по карте или моду вычёркивает его только в этом матче — пресет и списки не меняются.',
    'tools.match_pool_mods': 'Моды',
    'tools.match_pool_maps': 'Карты',
    'tools.match_settings': 'Настроить',
    'tools.match_game_date': 'Дата и время',
    'tools.match_add_game': 'Добавить в список игр',
    'tools.match_add_game_hint':
        '{n} игроков, карта и мод подставятся в форму новой игры.',
    'tools.match_add_game_no_players':
        'Добавьте хотя бы двух участников — они подставятся в форму новой игры.',
    'tools.match_add_game_forbidden':
        'Добавлять игры могут только модераторы и админы.',
    'tools.match_add_game_replay_hint':
        'Игра уже сыграна? Загрузите реплей или перетащите файл .SC2Replay в любое место страницы — участники, карта и дата подставятся автоматически.',
    'tools.match_replay_title': 'Импорт из реплея',
    'tools.match_replay_choose': 'Выбрать файл реплея',
    'tools.match_replay_applied':
        'Матч заполнен из реплея: участники, карта и дата. Проверьте данные.',
    'tools.match_replay_drop_hint':
        'Участники, карта и дата заполнятся автоматически (.SC2Replay)',
    'tools.predict_title': 'Прогноз победителя',
    'tools.predict_desc':
        'Укажите участников, при желании карту и мод — покажем предполагаемые места и шанс на победу с учётом истории игр.',
    'tools.predict_players': 'Игроки',
    'tools.predict_run': 'Рассчитать прогноз',
    'tools.predict_results': 'Результат',
    'tools.predict_chart_title': 'Шансы на победу',
    'tools.predict_details_title': 'Из чего складываются шансы',
    'tools.predict_random': 'Перебросить победителя',
    'tools.predict_random_hint':
        'Разыграть предварительного победителя по рассчитанным шансам (чем выше шанс, тем больше вероятность выпадения).',
    'tools.predict_random_winner': 'Предварительный победитель',
    'tools.predict_placeholder_title': 'Здесь появится прогноз',
    'tools.predict_placeholder_text':
        'Добавьте участников и нажмите «Рассчитать прогноз» — покажем шансы на победу и предполагаемые места.',
    'tools.predict_placeholder_loading': 'Считаем прогноз…',
    'tools.predict_need_two': 'Выберите хотя бы двух игроков.',
    'tools.predict_error': 'Не удалось рассчитать прогноз:',
    'tools.result_place': 'Место',
    'tools.result_player': 'Игрок',
    'tools.result_win_chance': 'Шанс на победу',
    'tools.result_context': 'Контекст',
    'tools.result_avg_place': 'ср. место',
    'tools.result_map_games': 'на карте',
    'tools.result_mod_games': 'с модом',
    'tools.race_none': 'Раса не выбрана',
    'tools.map_not_specified': 'Не указано',
    'tools.result_map': 'на карте',
    'tools.result_mod': 'с модом',
    'tools.reset': 'Сбросить',
    'tools.random_title': 'Выбор карты и режима',
    'tools.random_desc': 'Случайная карта и мод для следующей игры. Лишние можно исключить — выбор сохранится в браузере.',
    'tools.random_spin': 'Крутить!',
    'tools.random_map': 'Карта',
    'tools.random_mod': 'Мод',
    'tools.random_pool_maps': 'Пул карт',
    'tools.random_pool_mods': 'Пул модов',
    'tools.random_all': 'Все',
    'tools.random_none': 'Ничего',
    'tools.random_empty': 'Пул пуст',
    'tools.random_hint': 'Клик по названию исключает его из розыгрыша или возвращает обратно.',
    'tools.random_load_error': 'Не удалось загрузить карты и моды',
    'tools.random_no_mod': 'Без мода',
    'tools.random_search': 'Поиск карты…',
    'tools.random_search_mod': 'Поиск мода…',
    'tools.random_players': 'Игроков: {n}',
    'tools.random_type_toggle': 'Вся группа: включить/исключить все карты этого типа',
    'tools.random_players_toggle': 'Вся группа: включить/исключить все карты с этим числом игроков',
    'tools.random_search_by_type': 'Тип',
    'tools.random_search_by_players': 'Игроков',
    'tools.random_filters_title': 'Фильтр списка',
    'tools.random_filters_note': 'только показывает и скрывает строки — на розыгрыш не влияет',
    'tools.random_filters_reset': '✕ Сбросить',
    'tools.random_filters_reset_hint': 'Сбросить поиск и фильтры списка',
    'tools.random_section_reset': 'Снять все настройки раздела',
    'tools.random_groups_reset': 'Исключить все карты из розыгрыша',
    'tools.random_groups_title': 'Включить в розыгрыш',
    'tools.random_groups_note': 'клик по группе включает или исключает её целиком',
    'tools.random_groups_legend': '✓ вся группа · ◐ часть · ✕ выключена',
    'tools.random_types_format': 'Формат',
    'tools.random_types_teamformat': 'Формат команд',
    'tools.random_formats_toggle': 'Вся группа: включить/исключить все карты этого формата',
    'tools.random_types_style': 'Стиль игры',
    'tools.random_types_league': 'Лига',
    'tools.random_types_players': 'Игроков',
    'tools.random_tree_toggle': 'Свернуть или развернуть ветвь',
    'tools.random_shown': 'Показано {shown} из {total}',
    'tools.random_all_visible': 'Все видимые',
    'tools.random_none_visible': 'Ничего из видимых',
    'tools.random_all_hint': 'Действует на видимый список: поиск и фильтр учитываются',
    'tools.random_no_matches': 'Ничего не найдено — измените поиск или фильтр',
    'tools.random_group_selected': 'Выбрано',
    'tools.random_group_others': 'Остальные',
    'tools.random_view_label': 'Вид',
    'tools.random_view_list': 'Список',
    'tools.random_view_grid': 'Плитка',
    'tools.random_skip_unbalanced': 'Пропускать дисбалансные',
    'tools.random_skip_unbalanced_hint': 'Не вытягивать карты с пометкой «дисбалансная»',
    'tools.random_overlay': 'Выводить на оверлей OBS',
    'tools.random_overlay_hint': 'Прокрутка и результат появятся в OBS-оверлее (ссылка — в «Режиме стримера»). Нужен вход в аккаунт.',
    'tools.overlay_no_source': 'В OBS нет подключённого источника оверлея — розыгрыш и прогноз уйдут в никуда. Откройте ссылку из «Режима стримера» в OBS (Browser Source) и включите источник.',
    'tools.overlay_no_source_short': 'OBS не подключён',
    'tools.random_unbalanced_badge': 'Дисбалансная',
    'tools.random_mod_settings': 'Настройки мода',
    'tools.random_settings_reroll': '🎲 Заново',
    'tools.random_settings_fixed': 'фикс.',
    'tools.random_settings_off': 'Не рандомизируются',
    'tools.random_settings_off_hint': 'Клик — включить и рандомизировать',
    'tools.random_settings_presets': 'Пресеты:',
    'tools.random_settings_mode_random': '🎲 Случайные',
    'tools.random_settings_mode_preset': 'Пресет',
    'tools.random_settings_mode_hint': 'Источник значений настроек: случайный розыгрыш параметров или случайный пресет',
    'tools.preset_title': 'Пресеты',
    'tools.preset_current': '— текущий набор —',
    'tools.preset_league_maps': 'Все карты FFA Лига',
    'tools.preset_shared': 'Общие',
    'tools.preset_personal': 'Мои',
    'tools.preset_name': 'Название пресета',
    'tools.preset_scope_personal': 'Личный',
    'tools.preset_scope_shared': 'Общий',
    'tools.preset_save_new': 'Сохранить как новый',
    'tools.preset_update': 'Сохранить изменения',
    'tools.preset_reset': 'Сбросить изменения',
    'tools.preset_delete': 'Удалить',
    'tools.preset_delete_confirm': 'Удалить пресет «{name}»?',
    'tools.preset_modified': 'изменён',
    'tools.preset_login_hint': 'Войдите, чтобы сохранять свои пресеты',
    'tools.preset_exists': 'Пресет с таким названием уже есть',
    'tools.preset_error': 'Ошибка:',
    'tools.preset_saved': 'Сохранено',
    'tools.preset_subtitle':
        'Пресет сразу задаёт набор карт и модов для розыгрыша — не нужно вручную выключать лишнее.',
    'tools.preset_quick': 'Быстрый выбор',
    'tools.preset_empty_hint':
        'Сохранённых пресетов пока нет — соберите пул ниже и сохраните его, чтобы потом выбирать одним кликом.',
    'tools.preset_attention': 'Выберите пресет — иначе розыгрыш идёт по всему пулу.',
    'tools.preset_editor_title': 'Редактирование',
    'tools.preset_editor_hint':
        'Сохраните текущий набор карт и модов как новый пресет или обновите выбранный.',
    'tools.map_add_placeholder': 'Новая карта',
    'tools.map_add_alt_placeholder': 'Альт. название (необязательно)',
    'tools.map_add': '+ Добавить карту',
    'tools.map_exists': 'Такая карта уже есть',
    'leaderboard.title': 'Рейтинг',
    'leaderboard.empty': 'Пока никто не играл',
    'leaderboard.games': 'Игр',
    'leaderboard.wins': 'Побед',
    'leaderboard.winrate': 'Винрейт',

    'games.new_map_prompt': 'Название новой карты:',
    'games.new_map_error': 'Не удалось создать карту: ',
    'games.map_search_placeholder': 'Поиск карты…',
    'games.edit_map': 'Редактировать карту',
    'games.map_alt_placeholder': 'Альт. название (локализация)',
    'games.map_alt_save': 'Сохранить альтернативное название',
    'games.map_alt_saved': 'Сохранено',
    'games.map_alt_error': 'Не удалось сохранить альт. название',
    'games.field_map_type': 'Тип карты',
    'games.field_map_types': 'Типы карты',
    'games.map_type_saved': 'Типы сохранены',
    'games.map_type_error': 'Не удалось сохранить типы карты',
    'games.map_players_placeholder': 'Игроков',
    'games.map_players_saved': 'Число игроков сохранено',
    'games.map_players_error': 'Не удалось сохранить число игроков',

    // Типы карт
    'map_type.regular': 'Обычная',
    'map_type.team': 'Командная',
    'map_type.cb': 'КБ',
    'map_type.micro': 'Микро',
    'map_type.macro': 'Макро',
    'map_type.hybrid': 'Гибрид',
    'map_type.ffa_league': 'FFA Лига',

    // Формат командной карты
    'map_format.2v2': '2на2',
    'map_format.3v3': '3на3',
    'map_format.4v4': '4на4',
    'map_format.2v2v2': '2на2на2',
    'map_format.2v2v2v2': '2на2на2на2',
    'games.map_deleted': 'карта удалена',
    'games.map_deleted_hint': 'Карта отмечена как удалённая — поправьте запись игры',
    'games.map_deleted_warning': 'Карта «{name}» удалена. Выберите другую карту или восстановите её в админке.',
    'games.replay_map_not_found': 'Карта «{name}» не найдена в списке. Возможно, это та же карта под названием на другом языке. Добавьте вариант названия выбранной карте (поле ниже) либо создайте новую карту.',
    'games.replay_map_create': 'Создать карту из реплея',
    'games.new_mod_prompt': 'Название нового мода:',
    'games.new_mod_error': 'Не удалось создать мод: ',

    'games.filter_format': 'Формат',
    'games.filter_host': 'Проводящий',
    'games.filter_map': 'Карта',
    'games.filter_mod': 'Мод',
    'games.filter_player': 'Игрок',
    'games.filter_all': 'Все',
    'games.filter_reset': 'Сбросить фильтры',
    'games.click_to_filter': 'Нажмите, чтобы отфильтровать',

    // Колонки таблицы
    'players.col.name': 'Игрок',
    'players.col.race': 'Раса',
    'players.col.races': 'Расы',
    'players.col.stats': 'Статы',
    'players.col.total': 'Итого',
    'players.col.activity': 'Активность',

    // Параметры
    'stat.adaptiveness': 'Адаптивность',
    'stat.aggression': 'Агрессия',
    'stat.turtle': 'Черепашность',
    'stat.variety': 'Разнообразие',
    'stat.survival': 'Выживание',
    'stat.greed': 'Халява',

    // Зал славы
    'hall.title': 'Зал славы',
    'hall.subtitle': 'Лучшие и худшие по параметрам (от 2 оценок)',
    'hall.empty': 'Пока недостаточно оценок',
    'hall.high': 'Максимум',
    'hall.low': 'Минимум',
    'hall.adaptiveness.high': 'Самый адаптивный',
    'hall.adaptiveness.low': 'Самый прямолинейный',
    'hall.aggression.high': 'Самый агрессивный',
    'hall.aggression.low': 'Самый добрый',
    'hall.turtle.high': 'Самый оборонительный',
    'hall.turtle.low': 'Самый напористый',
    'hall.variety.high': 'Самый разнообразный',
    'hall.variety.low': 'Самый однотипный',
    'hall.survival.high': 'Самый живучий',
    'hall.survival.low': 'Самый хрупкий',
    'hall.greed.high': 'Самый жадный',
    'hall.greed.low': 'Самый бескорыстный',

    // Описание игрока (художественное, сдержанный тон). Варианты разделены `||`.
    'player.desc_title': 'Досье',
    'player.desc.race.terran':
        'Терран до мозга костей: дисциплина, выверенный план и недоверие к импровизации.||' +
        'Классический терран — крепкие тылы и порядок важнее спешки.||' +
        'Терранская школа: он верит в подготовку больше, чем в удачу.',
    'player.desc.race.zerg':
        'Дитя роя: там, где другие считают юнитов, он считает возможности.||' +
        'Зерг до кончиков когтей — напор, экономика и умение быть везде сразу.||' +
        'Типичный представитель роя: терпение, численность и неожиданные атаки.',
    'player.desc.race.protoss':
        'Протосс до кончиков пальцев: технологии, линии и безупречная осанка.||' +
        'Настоящий протосс — дорогие юниты и вера в собственное превосходство.||' +
        'Протосская школа: он ценит качество больше количества.',
    'player.desc.race.random':
        'Адепт случайности: даже сам не всегда знает, за кого играет.||' +
        'Random — его стихия: соперник в замешательстве, и это устраивает обоих.||' +
        'Он выбирает случайную расу — по крайней мере, так он говорит.',
    'player.desc.race.multi':
        'Универсал: освоил несколько рас, поэтому предугадать его непросто.||' +
        'Мастер на все расы — какая рука сегодня, решает настроение.||' +
        'Он играет за несколько рас, и соперникам это явно не упрощает жизнь.',
    'player.desc.race.unknown':
        'Таинственная фигура без примет: соперники ещё не составили на него досье.||' +
        'Тёмная лошадка — ни раса, ни почерк толком не известны.||' +
        'О нём известно немного, что само по себе интригует.',
    'player.desc.strong.adaptiveness':
        'Гибкость — его сильная сторона: он легко подстраивается под соперника и меняет план по ходу партии.||' +
        'Он быстро перестраивается, если ситуация того требует, и редко застревает на одной идее.||' +
        'Приспособляемость — его конёк: под любой матч-ап он найдёт рабочее решение.||' +
        'Он из тех, кто читает игру на ходу и меняет стратегию, не дожидаясь катастрофы.',
    'player.desc.strong.aggression':
        'Давление — его стиль: он не ждёт удобного момента, а старается его создать.||' +
        'Он предпочитает диктовать темп и держать соперника в напряжении с первых минут.||' +
        'Агрессия — его естественная среда: расслабиться рядом с ним не выйдет.||' +
        'Он любит инициативу и не боится ранних разменов.',
    'player.desc.strong.turtle':
        'Оборона — его стихия: он превращает базу в крепость и ждёт ошибок соперника.||' +
        'Он предпочитает надёжный тыл и не спешит покидать насиженные позиции.||' +
        'Терпеливая игра от обороны — его почерк: пусть торопится кто-нибудь другой.||' +
        'Он умеет выждать и сыграть на чужих ошибках, не форсируя события.',
    'player.desc.strong.variety':
        'Непредсказуемость — его козырь: заготовки угадать почти невозможно.||' +
        'Он не любит повторяться и почти каждую партию играет по-новому.||' +
        'Разнообразие — его девиз: соперникам остаётся только удивляться.||' +
        'Он импровизирует и часто находит нестандартные ходы.',
    'player.desc.strong.survival':
        'Он цепкий: выбывает последним и доживает там, где другие уже сдались.||' +
        'Выживание — его сильная сторона: его непросто добить в разгар рубки.||' +
        'Он тянет дольше, чем от него ожидают, и это нередко меняет исход партии.||' +
        'Живучесть — его тихое преимущество: первым он выбывает редко.',
    'player.desc.strong.greed':
        'Ресурсы — его страсть: он всегда возьмёт лишнюю базу, если выпадет шанс.||' +
        'Экономика для него порой важнее сражений: он любит отжать побольше.||' +
        'Он не упустит возможность расшириться и выжать из карты максимум.||' +
        'Без пары дополнительных баз партия кажется ему пресной.',
    'player.desc.weak.adaptiveness':
        'Правда, менять план по ходу партии он не спешит — импровизация даётся ему нелегко.||' +
        'Правда, если что-то пошло не по сценарию, он предпочтёт дожать старое, чем перестраиваться.||' +
        'Правда, гибкость — не его сильная сторона: новый расклад его немного сбивает.||' +
        'Правда, к резкой смене обстановки он приспосабливается с трудом.',
    'player.desc.weak.aggression':
        'Правда, агрессия — не про него: он предпочтёт выждать, даже когда момент зовёт в атаку.||' +
        'Правда, давить он не любит и нередко отдаёт инициативу сопернику.||' +
        'Правда, инициативу он берёт неохотно — реагировать ему комфортнее, чем нападать.||' +
        'Правда, ранние размены его не прельщают: он скорее сыграет наверняка.',
    'player.desc.weak.turtle':
        'Правда, удержать позицию до конца выходит не всегда — под давлением оборона порой трещит.||' +
        'Правда, стойкость в обороне — не его конёк, и натиск он выдерживает не всегда.||' +
        'Правда, окопаться как следует получается не всегда.||' +
        'Правда, длительную осаду он держит с трудом.',
    'player.desc.weak.variety':
        'Правда, с изобретательностью бывает туго: пара излюбленных заходов уже примелькалась.||' +
        'Правда, повторяться он не стесняется: если что-то работает, зачем что-то менять.||' +
        'Правда, фантазия его порой подводит, и шаблоны становятся предсказуемыми.||' +
        'Правда, набор идей у него невелик, и соперники это давно заметили.',
    'player.desc.weak.survival':
        'Правда, дожить до финала удаётся редко — в разгаре рубки он обычно выбывает рано.||' +
        'Правда, уцелеть в мясорубке — не его талант.||' +
        'Правда, на длинной дистанции его не хватает.||' +
        'Правда, затяжные партии он держит хуже, чем хотелось бы.',
    'player.desc.weak.greed':
        'Правда, лишний ресурс отжать он стесняется: экономика — не его религия.||' +
        'Правда, за своё он держится крепко, а вот отвоевать чужое не тянет.||' +
        'Правда, жадность не его конёк: он скорее доиграет на своём, чем полезет за добавкой.||' +
        'Правда, к расширению он относится без азарта.',
    'player.desc.trait.adaptiveness': 'гибкость',
    'player.desc.trait.aggression': 'агрессия',
    'player.desc.trait.turtle': 'основательная оборона',
    'player.desc.trait.variety': 'изобретательность',
    'player.desc.trait.survival': 'живучесть',
    'player.desc.trait.greed': 'тяга к ресурсам',
    'player.desc.also_strong': 'Да и {trait} ему, в общем, не чужда.||К тому же и {trait} у него в порядке.||А {trait} — приятный бонус к портрету.',
    'player.desc.also_weak': 'А {trait} у него, пожалуй, провисает.||Хотя {trait} явно не дотягивает.||Вот только {trait} подводит.',
    'player.desc.activity.high':
        'В лобби его видно постоянно — FFA для него явно больше, чем хобби.||' +
        'Он в игре почти всегда: складывается ощущение, что лобби без него пустует.||' +
        'Его можно застать в лобби почти в любое время.||' +
        'Активность у него высокая: он не пропускает подходящие вечера.',
    'player.desc.activity.mid':
        'В лобби он появляется регулярно: и не пропадает надолго, и не живёт в игре круглосуточно.||' +
        'Заходит стабильно — ровно настолько, чтобы не отставать.||' +
        'Он играет с завидной периодичностью, но без фанатизма.||' +
        'Его появление в лобби — привычная картина, хотя и не ежедневная.',
    'player.desc.activity.low':
        'Заходит на огонёк: пара партий — и снова пропадает.||' +
        'В лобби его встретишь нечасто, поэтому каждая партия с ним почти событие.||' +
        'Он появляется редко, но стабильно напоминает о себе.||' +
        'Играет он наездами, между другими делами.',
    'player.desc.skill.high':
        'Результаты не отстают от стиля: побед у него заметно больше, чем поводов для оправданий.||' +
        'Играет он уверенно, и таблица это подтверждает.||' +
        'Его результаты говорят сами за себя.||' +
        'Он стабильно добивается своего — соперники подтвердят.',
    'player.desc.skill.mid':
        'Результаты держатся на крепком среднем уровне: без фанфар, но и без поводов для паники.||' +
        'Итоги ровные: ни взлётов, ни провалов.||' +
        'Он держится в середине и не даёт поводов списывать себя со счетов.||' +
        'Результат стабильно средний — надёжно, хотя и без ярких вспышек.',
    'player.desc.skill.low':
        'С результатами пока скромнее, но потенциал явно есть.||' +
        'Победы даются нелегко: сказываются опыт и высокая конкуренция.||' +
        'Результаты пока не блещут, зато пространство для роста большое.||' +
        'Пока он скорее набирается опыта, чем собирает победы.',
    'player.desc.no_games': 'В деле его ещё толком не видели — легенда пока существует в основном на бумаге.',
    'player.desc.no_ratings': 'Оценок ему ещё не выставили, так что судить приходится по делам, а не по рассказам.',

    // Карточка игрока
    'player.votes': 'Голосов',
    'player.vote': 'Голос',
    'player.total': 'Итого',
    'player.back': '← Назад',
    'player.rating_edit': '✎ Изменить мою оценку',
    'player.rating_add': '+ Добавить оценку',
    'player.rating_delete': '🗑 Удалить мою оценку',
    'player.rating_delete_confirm': 'Удалить вашу оценку? Это действие нельзя отменить.',
    'player.rating_save': 'Сохранить',
    'player.rating_saving': 'Сохранение…',
    'player.rating_save_error': 'Не удалось сохранить оценку: ',
    'player.rating_delete_error': 'Не удалось удалить: ',
    'player.aka_edit': 'Aka',
    'player.aka_title': 'Альтернативные имена для "{name}" (через запятую):',
    'player.aka_save_error': 'Не удалось сохранить: ',
    'player.name_edit': '✎ Имя',
    'player.name_title': 'Новое имя для "{name}":',
    'player.name_empty_error': 'Имя не может быть пустым',
    'player.name_save_error': 'Не удалось переименовать: ',
    'player.login_to_rate': 'Войдите, чтобы оценивать игроков.',
    'player.rating_disabled': 'Администратор отключил вам возможность ставить оценки.',
    'player.login_link': 'Войти',
    'player.edit_title': 'Редактирование оценки',
    'player.edit_save': 'Сохранить',
    'player.edit_cancel': 'Отмена',
    'player.next_player': 'Следующий',
    'player.card_mode_average': 'Средняя',
    'player.card_mode_mine': 'Моя',
    'player.card_mode_ghost': 'По GHOSTу',
    

    // Оценки
    'ratings.title': 'Оценки пользователей',
    'ratings.empty_anonymous': 'Войдите, чтобы увидеть, кто и как оценил игрока.',
    'ratings.empty': 'Пока никто не оценил этого игрока.',
    'ratings.col.user': 'Пользователь',
    'ratings.link_to_player_title': 'Перейти к игроку',
    'ratings.col.race': 'Раса',
    'ratings.col.tier': 'Тир',
    'player.tier_title': 'Тир',
    'player_card.place_held': '{n} дн.',
    'player_card.place_held_today': 'сегодня',
    'player.tier_unset': 'Не указан',
    'player.tier_notice': 'Теперь при оценивании можно указать тир игрока. Обновите свою оценку и добавьте тир — так будет видно, насколько силён игрок.',
    'ratings.given_title': 'Оценки, поставленные игроком',
    'ratings.given_empty': 'Игрок пока никого не оценил.',
    'ratings.col.player': 'Игрок',
    'ratings.excluded': 'не учитывается',
    'ratings.excluded_title': 'Эта оценка не учитывается в средней оценке игрока',
    'ratings.admin_delete': 'Удалить оценку (админ)',
    'ratings.admin_delete_confirm': 'Удалить эту оценку?',
    'ratings.admin_delete_error': 'Не удалось удалить оценку',
    'ratings.admin_delete_all': 'Удалить все',
    'ratings.admin_delete_all_confirm': 'Удалить все оценки этого игрока?',
    'ratings.admin_delete_all_given_confirm': 'Удалить все оценки, поставленные этим игроком?',

    // Футер
    'footer.made_by': 'Made by',
    'footer.inspired_by': 'Inspired by',
    'footer.discord_copy': 'Скопировать тег',

    // Страница control
    'control.title': 'OVERLAY CONTROL',
    'control.connected': 'Подключено',
    'control.disconnected': 'Нет связи',
    'control.overlay_off': 'Оверлей не подключён',
    'control.overlay_off_hint': 'Источник в OBS не подключён к серверу — карточки и виджеты не покажутся. Скопируйте ссылку выше в OBS (Browser Source) и включите источник. Если ссылку перевыпускали — обновите её в OBS. Кнопка «Открыть» покажет причину, если дело в токене.',
    'control.overlay_sources': 'Источников OBS:',
    'control.obs_panel_title': 'OBS BROWSER SOURCE',
    'control.obs_hint': 'Скопируйте ссылку ниже и вставьте её в OBS как Browser Source. Оставьте источник включённым — карточки будут появляться автоматически.',
    'control.copy_url': 'Копировать',
    'control.open_overlay': 'Открыть',
    'control.regenerate_token': 'Перевыпустить',
    'control.regenerate_confirm': 'Перевыпустить токен?\n\nСтарая ссылка для OBS перестанет работать. Вам нужно будет обновить её в источнике OBS.',
    'control.regenerate_done': 'Готово',
    'control.regenerate_error': 'Не удалось перевыпустить токен: ',
    'control.copy_error': 'Скопируйте ссылку вручную (Ctrl+C / Cmd+C)',
    'control.players_title': 'ИГРОКИ',
    'control.players_search': 'Поиск игрока…',
    'control.preview_title': 'ПРЕВЬЮ КАРТОЧКИ',
    'control.preview_empty': 'Карточка не показывается',
    'control.preview_error': 'Не удалось загрузить превью',
    'control.rated_players': 'С оценками',
    'control.unrated_players': 'Без оценок, но с играми',
    'control.pinned_title': 'Закреплённые',
    'control.unpin': 'Открепить',
    'control.pin': 'Закрепить сверху',
    'control.pinned_hint': 'Закрепляйте игроков сами или из «Менеджера матча» — они будут сверху списка.',
    'control.pin_mode_label': 'Режим закрепления',
    'control.pin_mode_hint': 'Показывает у игроков кнопки закрепления 📌. Выключено — кнопки скрыты.',
    'control.show_title': 'ПОКАЗ',
    'control.hide_button': ' ✕ Скрыть карточку',
    'control.current_nothing': 'Ничего не показывается',
    'control.current_prefix': 'Сейчас: ',
    'control.widget_prefix': 'Виджет: ',
    'control.widget_predict': 'Прогноз матча',
    'control.widget_game': 'Превью игры',
    'control.hide_widget': 'Скрыть виджет',
    'control.settings_title': 'НАСТРОЙКИ',
    'control.animation_label': 'Анимация появления',
    'control.animation_fade': 'Fade',
    'control.animation_slide_left': 'Вылет слева',
    'control.animation_slide_right': 'Вылет справа',
    'control.animation_slide_up': 'Вылет снизу',
    'control.animation_slide_down': 'Вылет сверху',
    'control.animation_none': 'Без анимации',
    'control.autohide_label': 'Автоматически скрывать карточку через время',
    'control.autohide_delay_label': 'Скрывать через (секунд)',
    'control.view_mode_label': 'Режим показа',
    'control.view_mode_average': 'Средние оценки',
    'control.view_mode_personal': 'Мои оценки',
    'control.view_mode_ghost': 'Оценка по GHOSTу',
    'control.token_error': 'Ошибка загрузки токена',
    'control.show_error': 'Не удалось показать: ',
    'control.hide_error': 'Не удалось скрыть: ',
    'control.settings_error': 'Не удалось сохранить настройки: ',
    'control.no_players': 'Пока нет игроков с оценками',
    'control.back_to_main': 'На главную',

    // Админ-панель
    'admin.title': 'ADMIN PANEL',
    'admin.users_title': 'Пользователи',
    'admin.users_search': 'Поиск по email или нику…',
    'admin.players_title': 'Игроки',
    'admin.players_hint': 'Удаление игрока каскадно удалит все его оценки.',
    'admin.players_search': 'Поиск по имени или aka…',
    'admin.grant_mod': 'Выдать MOD',
    'admin.revoke_mod': 'Забрать MOD',
    'admin.grant_admin': 'Выдать ADMIN',
    'admin.revoke_admin': 'Забрать ADMIN',
    'admin.grant_ghost': 'Выдать GHOST',
    'admin.revoke_ghost': 'Забрать GHOST',
    'admin.role_toggle_confirm': 'Роль {role} у {email}?',
    'admin.role_toggle_error': 'Не удалось изменить роль: ',
    'admin.user_no_username': '— без ника —',
    'admin.no_users': 'Ничего не найдено',
    'admin.back_to_main': 'На главную',
    'admin.rename_button': 'Имя',
    'admin.aka_button': 'Aka',
    'admin.delete_button': 'Удалить',
    'admin.ratings_empty': 'Нет оценок',
    'admin.rating_delete_confirm': 'Удалить оценку пользователя "{user}"?',
    'admin.player_delete_confirm': 'Удалить игрока "{name}"?\n\nВсе его оценки ({count}) будут удалены безвозвратно.',
    'admin.registered_at': 'Регистрация',
    'admin.last_seen': 'Заходил',
    'admin.last_seen_just_now': 'только что',
    'admin.last_seen_minutes': '{n} мин назад',
    'admin.last_seen_hours': '{n} ч назад',
    'admin.last_seen_days': '{n} дн назад',
    'admin.delete_user': 'Удалить аккаунт',
    'admin.delete_user_confirm': 'Удалить аккаунт "{user}"?\n\nВсе его оценки, роли и данные будут безвозвратно удалены.',
    'admin.delete_user_error': 'Не удалось удалить: ',
    'admin.disable_rate': 'Исключить из средних',
    'admin.enable_rate': 'Учитывать в средних',
    'admin.disable_rate_title': 'Оценки пользователя не будут учитываться в средней оценке игроков (сам он их видит и может менять)',
    'admin.enable_rate_title': 'Оценки пользователя снова будут учитываться в средней оценке игроков',
    'admin.disable_rate_confirm': 'Исключить оценки пользователя "{user}" из средней оценки игроков? Он по-прежнему сможет ставить оценки и видеть их.',
    'admin.enable_rate_confirm': 'Снова учитывать оценки пользователя "{user}" в средней оценке игроков?',
    'admin.rate_toggle_error': 'Не удалось изменить учёт оценок: ',
    'admin.ban_user': 'Заблокировать',
    'admin.unban_user': 'Разблокировать',
    'admin.ban_title': 'Заблокировать аккаунт (запретит вход и оценивание)',
    'admin.unban_title': 'Разблокировать аккаунт',
    'admin.ban_confirm': 'Заблокировать пользователя "{user}"?\n\nОн не сможет войти и ставить оценки.',
    'admin.unban_confirm': 'Разблокировать пользователя "{user}"?',
    'admin.ban_error': 'Не удалось изменить статус блокировки: ',
    'admin.user_banned': '🔨 Заблокирован',
    'admin.impersonate': '↬ Войти как',
    'admin.impersonate_title': 'Войти под этим пользователем',
    'admin.impersonate_confirm': 'Войти под пользователем "{user}"?\n\nВы будете залогинены под его аккаунтом (до выхода/обновления страницы).',
    'admin.impersonate_error': 'Не удалось войти под пользователем: ',
    'admin.impersonate_banned': 'Пользователь заблокирован — вход невозможен.',
    'admin.view_stats': 'Статистика',
    'admin.view_stats_title': 'Посмотреть личную статистику игрока',
    'admin.set_password': 'Пароль',
    'admin.set_password_title': 'Задать новый пароль (старый недоступен — в Auth он хэширован)',
    'admin.set_password_confirm': 'Сбросить пароль пользователю "{user}"?\n\nБудет сгенерирован новый временный пароль — старый перестанет работать.',
    'admin.set_password_error': 'Не удалось сбросить пароль: ',
    'admin.password_show': 'Показать пароль',
    'admin.password_hide': 'Скрыть пароль',
    'admin.password_copy': 'Скопировать пароль',
    'admin.password_new_hint': 'Новый временный пароль (показывается один раз)',
    'admin.archive_title': 'Архив удалённых оценок',
    'admin.archive_search': 'Поиск по игроку или пользователю…',
    'admin.archive_total': 'Всего удалённых оценок в архиве: {n}',
    'admin.archive_empty': 'В архиве пока нет удалённых оценок.',
    'admin.archive_deleted': 'Удалено',
    'admin.archive_restore': 'Восстановить',
    'admin.archive_restore_all': 'Восстановить все этого юзера',
    'admin.archive_restore_all_title': 'Восстановить все удалённые оценки этого пользователя',
    'admin.archive_restore_confirm': 'Восстановить эту оценку?',
    'admin.archive_restore_all_confirm': 'Восстановить ВСЕ удалённые оценки этого пользователя?',
    'admin.archive_restore_error': 'Не удалось восстановить оценку: ',
    'admin.formats_title': 'Форматы игр',
    'admin.add_format': '+ Добавить формат',
    'admin.hosts_title': 'Ведущие',
    'admin.add_host': '+ Добавить ведущего',
    'admin.no_formats': 'Форматы пока не добавлены',
    'admin.no_hosts': 'Ведущие пока не добавлены',
    'admin.new_format_prompt': 'Название нового формата:',
    'admin.new_format_error': 'Не удалось создать формат: ',
    'admin.new_host_prompt': 'Имя нового ведущего:',
    'admin.new_host_error': 'Не удалось создать ведущего: ',
    'admin.delete_format_confirm': 'Удалить формат "{name}"?\n\nИгры с этим форматом останутся, но потеряют привязку.',
    'admin.delete_host_confirm': 'Удалить ведущего "{name}"?',
    'admin.host_player_none': '— не привязан —',
    'admin.host_player_title': 'Привязанный игрок (стример): карточка этого игрока покажет панель ведущего',
    'admin.elo_weight': 'Вес MMR (множитель)',

    'admin.maps_title': 'Карты',
    'admin.add_map': '+ Добавить карту',
    'admin.maps_search': 'Поиск по названию…',
    'admin.mods_title': 'Моды',
    'admin.add_mod': '+ Добавить мод',
    'admin.mods_search': 'Поиск по названию…',
    'admin.new_map_prompt': 'Название новой карты:',
    'admin.new_map_error': 'Не удалось создать карту: ',
    'admin.delete_map_confirm': 'Удалить карту "{name}"?\n\nИгры с этой картой останутся; в них карта будет помечена как удалённая.',
    'admin.alt_name_placeholder': 'Альт. название (локализация)',
    'admin.map_deleted_badge': 'удалена',
    'admin.map_players_placeholder': 'Игроков',
    'admin.map_players_title': 'Рекомендуемое число игроков карты',
    'admin.map_formats_title': 'Формат командной карты (учитывается, если отмечена «Командная»)',
    'admin.map_author_placeholder': 'Автор',
    'admin.map_link_placeholder': 'Ссылка (URL)',
    'admin.map_image_upload': 'Загрузить картинку',
    'admin.map_image_hover': 'Наведите, чтобы посмотреть; клик — заменить',
    'admin.map_image_remove': 'Удалить картинку',
    'admin.map_image_remove_confirm': 'Удалить картинку карты "{name}"?',
    'admin.map_image_error': 'Не удалось загрузить картинку: ',
    'admin.restore': 'Восстановить',
    'admin.new_mod_prompt': 'Название нового мода:',
    'admin.new_mod_error': 'Не удалось создать мод: ',
    'admin.delete_mod_confirm': 'Удалить мод "{name}"?\n\nИгры с этим модом останутся, но потеряют привязку.',
    'admin.titles_title': 'Титулы',
    'admin.add_title': '+ Добавить титул',
    'admin.titles_hint': 'Титул показывается в карточке игрока справа сверху и в оверлее.',
    'admin.titles_empty': 'Титулов пока нет. Добавьте первый, чтобы выдать его игрокам.',
    'admin.new_title_prompt': 'Название нового титула:',
    'admin.new_title_error': 'Не удалось создать титул: ',
    'admin.delete_title_confirm': 'Удалить титул "{name}"?\n\nТитул будет снят со всех игроков.',
    'admin.title_select_player': '— выберите игрока —',
    'admin.title_add_player': '+ Выдать',
    'admin.title_unassign': 'Снять титул',
    'admin.title_name_en_placeholder': 'Перевод на англ. (EN-локали)',
    'admin.title_name_en_title': 'Показывается вместо названия, когда сайт на английском. Пусто — используется русское название.',
    'common.empty': 'пусто',

    'title.color_gold': 'Золото',
    'title.color_blue': 'Синий (терран)',
    'title.color_purple': 'Фиолетовый (зерг)',
    'title.color_yellow': 'Жёлтый (протосс)',
    'title.color_gray': 'Серый (рандом)',
    'title.color_red': 'Красный',
    'title.color_green': 'Зелёный',
    'title.color_cyan': 'Голубой',
    'title.color_orange': 'Оранжевый',
    'title.color_pink': 'Розовый',

    'title.size_label': 'Размер',
    'title.size_small': 'Минимальный',
    'title.size_medium': 'Средний',
    'title.size_large': 'Крупный',
    'title.size_xlarge': 'Очень крупный',

    'admin.link_user': 'Связать',
    'admin.link_user_title': 'Связать игрока с профилем пользователя',
    'admin.link_user_prompt': 'Email или никнейм пользователя для игрока "{name}":',
    'admin.link_user_error': 'Не удалось связать: ',
    'admin.unlink_user': 'Отвязать',
    'admin.unlink_user_title': 'Отвязать игрока от профиля пользователя',
    'admin.unlink_user_confirm': 'Отвязать игрока "{name}" от профиля пользователя?',
    'admin.linked_player': 'Связан с игроком',
    'admin.user_linked_player': 'Игрок: {name}',
    'admin.my_profile': 'Мой профиль',

    'admin.logs_title': 'Лог действий',
    'admin.logs_search': 'Поиск по тексту или пользователю…',
    'admin.logs_filter_all': 'Все действия',
    'admin.logs_empty': 'Пока нет записей',
    'admin.logs_refresh': 'Обновить',
    'admin.logs_actor': 'Пользователь',
    'admin.logs_system': 'система',

    'admin.visits_title': 'Посещения сайта',
    'admin.visits_hint': 'Просмотры страниц собираются автоматически при переходах по сайту. Боты, админка и страница управления оверлеем не учитываются.',
    'admin.visits_days_7': '7 дней',
    'admin.visits_days_30': '30 дней',
    'admin.visits_days_90': '90 дней',
    'admin.visits_views': 'Просмотры',
    'admin.visits_visitors': 'Уникальные посетители',
    'admin.visits_registered': 'Авторизованные',
    'admin.visits_top': 'Популярные страницы',
    'admin.visits_log_title': 'Лог посещений',
    'admin.visits_search': 'Поиск по странице, referrer или UA…',
    'admin.visits_empty': 'Пока нет посещений',
    'admin.visits_anonymous': 'аноним',
    'admin.visits_direct': 'прямой заход',

    'log.action.signup': 'Регистрация',
    'log.action.login': 'Вход',
    'log.action.logout': 'Выход',
    'log.action.player_create': 'Добавлен игрок',
    'log.action.player_rename': 'Переименование игрока',
    'log.action.player_aka': 'Изменение aka',
    'log.action.player_delete': 'Удалён игрок',
    'log.action.player_link': 'Привязка профиля',
    'log.action.player_unlink': 'Отвязка профиля',
    'log.action.rating_create': 'Добавлена оценка',
    'log.action.rating_update': 'Изменена оценка',
    'log.action.rating_delete': 'Удалена оценка',
    'log.action.game_create': 'Добавлена игра',
    'log.action.game_update': 'Изменена игра',
    'log.action.game_delete': 'Удалена игра',
    'log.action.ref_create': 'Добавлен справочник',
    'log.action.ref_update': 'Изменён справочник',
    'log.action.ref_delete': 'Удалён справочник',
    'log.action.role_grant': 'Выдана роль',
    'log.action.role_revoke': 'Снята роль',
    'log.action.user_delete': 'Удалён пользователь',
    'log.action.user_rate_allow': 'Разрешены оценки',
    'log.action.user_rate_block': 'Запрещены оценки',
    'log.action.user_ban': 'Заблокирован пользователь',
    'log.action.user_unban': 'Разблокирован пользователь',
    'log.action.auth_forgot_password': 'Запрос сброса пароля',
    'log.action.auth_reset_password': 'Сброс пароля по почте',
    'log.action.rating_restore': 'Восстановлена оценка',
    'log.action.preset_create': 'Создан пресет',
    'log.action.preset_update': 'Изменён пресет',
    'log.action.preset_delete': 'Удалён пресет',
    'log.action.title_create': 'Создан титул',
    'log.action.title_update': 'Изменён титул',
    'log.action.title_delete': 'Удалён титул',
    'log.action.title_assign': 'Выдан титул',
    'log.action.title_unassign': 'Снят титул',
    'log.action.user_impersonate': 'Имперсонация',
    'log.action.user_set_password': 'Сброс пароля',
    'log.action.user_update_username': 'Смена ника',
    'log.action.user_update_email': 'Смена почты',
    'log.action.user_update_password': 'Смена пароля',
    'log.action.reaction_player': 'Реакция на игрока',
    'log.action.reaction_game': 'Реакция на игру',
    'log.action.reaction_mvp': 'Голос MVP',
    'log.action.reaction_map': 'Голос за карту',
    'log.action.reaction_mod': 'Голос за мод',
    'log.action.follow_add': 'Подписка на игрока',
    'log.action.follow_remove': 'Отписка от игрока',
    'log.action.share_card': 'Поделился карточкой',
    'topbar.my_profile': 'Мой профиль',

    // Личный профиль (/profile)
    'profile.title': 'Личный профиль',
    'profile.username_title': 'Имя профиля',
    'profile.username_hint': 'Ник показывается в шапке сайта и в списке оценок.',
    'profile.username_placeholder': 'Ник (3-32 символа)',
    'profile.email_title': 'Почта',
    'profile.email_hint': 'На эту почту приходят письма сайта. Смена подтверждается текущим паролем.',
    'profile.email_placeholder': 'Email',
    'profile.password_title': 'Пароль',
    'profile.password_hint': 'Минимум 6 символов. После смены пароля старый перестанет работать.',
    'profile.current_password_placeholder': 'Текущий пароль',
    'profile.new_password_placeholder': 'Новый пароль (мин. 6)',
    'profile.repeat_password_placeholder': 'Повторите новый пароль',
    'profile.game_profile_title': 'Игровой профиль',
    'profile.game_profile_hint': 'Ваша карточка игрока с оценками, статистикой и историей игр.',
    'profile.game_profile_open': 'Открыть игровой профиль',
    'profile.game_profile_unlinked': 'Игровой профиль ещё не привязан к аккаунту. Попросите модератора привязать его.',
    'profile.save': 'Сохранить',
    'profile.saving': 'Сохранение…',
    'profile.saved': 'Сохранено',
    'profile.error_username_invalid': 'Ник: 3-32 символа, только латиница, цифры, _, ., -',
    'profile.error_username_taken': 'Этот ник уже занят',
    'profile.error_email_invalid': 'Некорректный email',
    'profile.error_email_taken': 'Эта почта уже используется',
    'profile.error_wrong_password': 'Неверный текущий пароль',
    'profile.error_password_short': 'Пароль должен быть не короче 6 символов',
    'profile.error_password_mismatch': 'Пароли не совпадают',
    'profile.error_generic': 'Не удалось сохранить изменения. Попробуйте ещё раз.',

    // Личная статистика (/my-stats)
    'topbar.my_stats': 'Моя статистика',
    'mystats.title': 'Моя статистика',
    'mystats.player_title': 'Статистика игрока {name}',
    'mystats.player': 'Игрок',
    'mystats.mmr': 'MMR',
    'mystats.rank_value': '#{rank} из {total}',
    'mystats.games': 'Игры',
    'mystats.wins': 'Победы',
    'mystats.winrate_short': 'побед',
    'mystats.avg_place': 'Среднее место',
    'mystats.activity': 'Активность',
    'mystats.game_days': 'Игровых дней',
    'mystats.elo_30d': 'MMR за 30 дней',
    'mystats.games_30d': '{n} игр за 30 дней',
    'mystats.elo_title': 'Динамика MMR',
    'mystats.elo_hint': 'По последним {n} играм.',
    'mystats.rhythm_title': 'Игровой ритм',
    'mystats.rhythm_hint': 'Когда ты играешь (МСК): насыщенность — число игр, цвет — винрейт.',
    'mystats.heatmap_cell': '{games} игр · {winrate}% побед',
    'mystats.heatmap_wr_low': '0% побед',
    'mystats.heatmap_wr_high': '100% побед',
    'mystats.timeline_title': 'Хроника мест',
    'mystats.timeline_hint': 'Последние 30 игр: выше — лучше место. Клик открывает игру.',
    'mystats.timeline_win': 'победа',
    'mystats.timeline_top': 'верхняя половина',
    'mystats.timeline_bottom': 'нижняя половина',
    'mystats.ach_title': 'Достижения',
    'mystats.ach_hint': 'Открываются по мере игры.',
    'mystats.ach_done': 'Получено',
    'mystats.ach.first_win': 'Первая победа',
    'mystats.ach.games_10': '10 игр',
    'mystats.ach.games_50': '50 игр',
    'mystats.ach.games_100': '100 игр',
    'mystats.ach.streak_5': '5 побед подряд',
    'mystats.ach.streak_10': '10 побед подряд',
    'mystats.ach.winrate_55': 'Винрейт 55%',
    'mystats.ach.big_lobby': 'Победа в лобби 6+',
    'mystats.ach.map_master': '100% на карте',
    'mystats.ach.survivor': '10 финишей в топ-2',
    'mystats.ach.night_owl': '10 ночных игр',
    'mystats.ach.all_races': 'Все три расы',
    'mystats.ach.veteran': '30 игровых дней',
    'mystats.pct_title': 'Ты в лиге',
    'mystats.pct_hint': 'Сколько игроков ты обходишь по каждому показателю.',
    'mystats.pct_better': 'лучше {percent}% игроков',
    'mystats.pct.mmr': 'MMR',
    'mystats.pct.winrate': 'Винрейт',
    'mystats.pct.avg_place': 'Среднее место',
    'mystats.pct.activity': 'Активность',
    'mystats.pct.games': 'Игры',
    'mystats.style_title': 'Стиль игры',
    'mystats.style_hint': 'Твоя средняя оценка против среднего по лиге (1–5).',
    'mystats.style_mine': 'Ты',
    'mystats.style_league': 'Лига',
    'mystats.style_votes': '{n} оценок',
    'mystats.style_no_votes': 'Пока нет оценок стиля — попроси поставить их в карточке игрока.',
    'mystats.arch_title': 'Типаж игрока',
    'mystats.arch_hint': 'Собран из оценок стиля и твоих игр: важны не абсолютные баллы, а твои сильные стороны относительно личного профиля.',
    'mystats.arch_disclaimer': 'Типаж и тильт рассчитаны по ограниченной статистике — могут быть не очень точными.',
    'mystats.arch_match': 'выраженность',
    'mystats.arch_sources': 'Учтено: {games} игр и {votes} оценок стиля.',
    'mystats.arch_near': 'Близок к: {arch} ({match}%)',
    'mystats.arch_part_style': 'стиль',
    'mystats.arch_part_games': 'игры',
    'mystats.signal.quick_wins': 'быстрых побед {percent}%',
    'mystats.signal.fast_games': 'игр до 15 мин {percent}%',
    'mystats.signal.short_edge': 'в коротких играх {percent}% к своему уровню',
    'mystats.signal.win_length': 'победы в среднем {minutes} мин',
    'mystats.signal.long_games': 'игр 25+ мин {percent}%',
    'mystats.signal.late_edge': 'в долгих играх {percent}% к своему уровню',
    'mystats.signal.survives': 'обгоняет {percent}% лобби',
    'mystats.signal.top2_games': 'топ-2 в {percent}% игр',
    'mystats.signal.first_out_games': 'первым вылетает в {percent}% игр',
    'mystats.tilt_title': 'Тильт',
    'mystats.tilt_calm': 'Спокоен',
    'mystats.tilt_tilted': 'Тильтует',
    'mystats.tilt.decay': 'Спад за день: {value}',
    'mystats.tilt.breaks': 'Пропуск после слабой: {value}',
    'mystats.tilt_level.calm': 'Невозмутимый',
    'mystats.tilt_level.steady': 'Ровный',
    'mystats.tilt_level.variable': 'Переменчивый',
    'mystats.tilt_level.volatile': 'Нестабильный',
    'mystats.tilt_level.tilted': 'Тильтующий',
    'mystats.tilt_desc.calm':
      'Держит место от первой игры дня к последней и после слабой игры продолжает как обычно, без длинных пауз.',
    'mystats.tilt_desc.steady':
      'Иногда проседает к концу дня или берёт паузу после слабой игры, но быстро возвращается к своему уровню.',
    'mystats.tilt_desc.variable':
      'Форма заметно зависит от дня: к вечеру может просесть, а после слабой игры — пропустить одну-две игры.',
    'mystats.tilt_desc.volatile':
      'Часто сдаёт к концу игрового дня и после слабой игры уходит из лобби на длинную паузу.',
    'mystats.tilt_desc.tilted':
      'Разваливается по ходу дня и почти всегда пропускает игры после слабой — тильт накапливается за сессию.',
    'mystats.arch_dist_title': 'Типажи в лиге',
    'mystats.arch_dist_hint':
      'Распределение по типажам: важна форма стиля — сильные стороны относительно личного профиля. Приглушённые типажи пока не встретились ни у кого в лиге.',
    'mystats.arch_dist_total': 'Учтено {n} игроков — у кого есть оценки стиля или хотя бы 3 игры.',
    'mystats.arch_dist_you': 'ты',
    'mystats.arch_dist_more': 'Показать все типажи (+{n})',
    'mystats.arch_dist_less': 'Свернуть',
    'mystats.arch_axis.aggression': 'Агрессия',
    'mystats.arch_axis.greed': 'Экономика',
    'mystats.arch_axis.turtle': 'Оборона',
    'mystats.arch.usurper.name': 'Узурпатор',
    'mystats.arch.usurper.desc': 'Бескомпромиссный all-in и раннее давление: ломает соседа с первых минут, не жалея экономики.',
    'mystats.arch.magnate.name': 'Магнат',
    'mystats.arch.magnate.desc': 'Абсолютная жадность: множит базы и рабочих, пока соседи заняты друг другом.',
    'mystats.arch.fortress.name': 'Крепость',
    'mystats.arch.fortress.desc': 'Глухая оборона: застраивает базу и ждёт, пока соперники разобьются о его позиции.',
    'mystats.arch.raider.name': 'Экспансионист-Рейдер',
    'mystats.arch.raider.desc': 'Агрессивное макро: ранний пуш, чтобы выбить соседа, забрать его ресурсы и уйти в отрыв.',
    'mystats.arch.punisher.name': 'Каратель',
    'mystats.arch.punisher.desc': 'Контр-атаки: держит прочную оборону, копит лимит и бьёт по тем, кто открылся.',
    'mystats.arch.syndicate.name': 'Синдикат',
    'mystats.arch.syndicate.desc': 'Безопасное макро: каждая база ставится под прикрытием армии и пушек, выход в идеальный лейт.',
    'mystats.arch.grandmaster.name': 'Гроссмейстер',
    'mystats.arch.grandmaster.desc': 'Универсал: действует по ситуации, без перекосов в агрессию, экономику или оборону.',
    'mystats.arch.titan.name': 'Титан',
    'mystats.arch.titan.desc': 'Максимальное давление на всех фронтах: и атака, и экономика, и оборона на высоте.',
    'mystats.arch.observer.name': 'Созерцатель',
    'mystats.arch.observer.desc': 'Не форсирует события: играет от ситуации и не вкладывается в один вектор сверх меры.',
    'mystats.arch.conqueror.name': 'Завоеватель',
    'mystats.arch.conqueror.desc': 'Давит и развивается одновременно, не забывая про оборону.',
    'mystats.arch.gladiator.name': 'Гладиатор',
    'mystats.arch.gladiator.desc': 'Атака и оборона на высоте: бьёт и держит удар, экономика вторична.',
    'mystats.arch.vanguard.name': 'Авангард',
    'mystats.arch.vanguard.desc': 'Агрессия — главный инструмент, остальное по ситуации.',
    'mystats.arch.skirmisher.name': 'Штурмовик',
    'mystats.arch.skirmisher.desc': 'Быстро давит, не вкладываясь в экономику и не строя оборону.',
    'mystats.arch.berserker.name': 'Берсерк',
    'mystats.arch.berserker.desc': 'Не жалеет экономики ради давления, но не забывает прикрыть базу.',
    'mystats.arch.guardian.name': 'Хранитель',
    'mystats.arch.guardian.desc': 'Копит экономику и оборону, нападая только по удобному случаю.',
    'mystats.arch.tycoon.name': 'Делец',
    'mystats.arch.tycoon.desc': 'Экономика — главный козырь, остальное подстраивается.',
    'mystats.arch.warden.name': 'Страж',
    'mystats.arch.warden.desc': 'Оборона — главный инструмент, остальное по ситуации.',
    'mystats.arch.gambler.name': 'Азартный',
    'mystats.arch.gambler.desc': 'Не строит оборону, но и не давит: играет на грани, надеясь на темп.',
    'mystats.arch.citadel.name': 'Цитадель',
    'mystats.arch.citadel.desc': 'Мощная оборона при скромной экономике: держит позиции и ждёт ошибок.',
    'mystats.arch.sentinel.name': 'Часовой',
    'mystats.arch.sentinel.desc': 'Осторожный стиль: не жадничает, но и не лезет вперёд.',
    'mystats.arch.drifter.name': 'Скиталец',
    'mystats.arch.drifter.desc': 'Не давит и не защищается: играет от случая и темпа.',
    'mystats.arch.farmer.name': 'Фермер',
    'mystats.arch.farmer.desc': 'Спокойно развивается, избегая агрессии и лишнего риска.',
    'mystats.arch.trencher.name': 'Окопник',
    'mystats.arch.trencher.desc': 'Осторожный и оборонительный, но без фанатизма: держит базу и копит.',
    'archetypes.open_all': 'Посмотреть все типажи',
    'archetypes.title': 'Все типажи',
    'archetypes.intro': '23 типажа лиги: из чего складывается каждый, сколько игроков в нём и кто выражен сильнее всех. Клик по нику открывает карточку игрока.',
    'archetypes.total': 'Учтено {n} игроков — у кого есть оценки стиля или хотя бы 3 игры.',
    'archetypes.count': '{n} игроков · {percent}%',
    'archetypes.level.L': 'низко',
    'archetypes.level.M': 'средне',
    'archetypes.level.H': 'высоко',
    'archetypes.players': 'Представители',
    'archetypes.no_players': 'Пока ни у кого не выражен',
    'archetypes.games': '{n} игр',
    'archetypes.empty': 'Типажи ещё не рассчитаны — нужно больше оценок стиля или игр.',
    'mystats.mod.polyglot': 'Полиглот',
    'mystats.mod.chameleon': 'Хамелеон',
    'mystats.mod.experimenter': 'Экспериментатор',
    'mystats.mod.dogmatist': 'Догматик',
    'mystats.trait.fast_wins': 'Быстрые победы — {percent}%',
    'mystats.trait.long_wins': 'Долгие победы — в среднем {minutes} мин',
    'mystats.trait.short_games': 'Короткие игры — {percent}%',
    'mystats.trait.marathon': 'Марафоны 25+ мин — {percent}%',
    'mystats.trait.late_boom': 'Лейт сильнее — +{percent}% к своему уровню',
    'mystats.trait.early_pressure': 'Давит сразу — +{percent}% в коротких играх',
    'mystats.trait.survivor': 'Доживает до {percent}% лобби',
    'mystats.trait.top2': 'Топ-2 в {percent}% игр',
    'mystats.trait.top_half': 'Верхняя половина — {percent}% игр',
    'mystats.trait.first_out': 'Первый вылет — {percent}% игр',
    'mystats.trait.early_risk': 'Рано вылетает — {percent}% игр',
    'mystats.trait.consistent': 'Стабильные места — разброс {spread}%',
    'mystats.trait.swingy': 'Качели — разброс {spread}%',
    'mystats.trait.night_owl': 'Ночные игры — {percent}%',
    'mystats.trait.weekend': 'Выходные — {percent}% игр',
    'mystats.trait.polyglot': 'Играет на {n} расах',
    'mystats.trait.mono_race': 'Одна раса — {race}, {percent}% игр',
    'mystats.trait.specialist': 'Узкий пул — {n} карт',
    'mystats.trait.adaptable': 'Гибкий стиль',
    'mystats.trait.map_spread': 'Пул из {n} карт',
    'mystats.trait.comfort_map': 'Любимая карта — {percent}% игр',
    'mystats.trait.streaky': 'Серия до {n} побед',
    'mystats.trait.big_lobby': 'Победы в 6+ — {n}',
    'mystats.trait.active': 'Активность — {n} игр за 30 дней',
    'mystats.trait.evening': 'Пик формы около {hour}:00',
    'mystats.trait.rival_hunter': 'Гроза {name} — {winrate}% побед',
    'mystats.trait.never_wins': 'Без побед за {games} игр',
    'mystats.survival_title': 'Выживаемость',
    'mystats.survival_hint': 'Как долго держишься в лобби и когда выигрываешь.',
    'mystats.survival_share': 'Доля лобби',
    'mystats.survival_top2': 'Финиши в топ-2',
    'mystats.survival_avg_win': 'Средняя победа',
    'mystats.lobby_title': 'Размер лобби',
    'mystats.lobby_hint': 'Винрейт в зависимости от числа игроков.',
    'mystats.lobby_size': '{n} игрока',
    'mystats.lobby_size_plus': '6+ игроков',
    'mystats.h2h_title': 'Личные счёты',
    'mystats.h2h_hint': 'Кого чаще обыгрываешь, а кому чаще уступаешь.',
    'mystats.h2h_best': 'Любимая жертва',
    'mystats.h2h_worst': 'Личный тренер',
    'mystats.wrapped_title': 'Итоги месяца',
    'mystats.wrapped_hint': 'Короткая сводка текущего месяца.',
    'mystats.wrapped_empty': 'В этом месяце игр пока нет — сыграй, и итоги появятся.',
    'mystats.wrapped_elo': 'MMR за месяц',
    'mystats.wrapped_map': 'Любимая карта',
    'mystats.wrapped_rival': 'Частый соперник',
    'mystats.wrapped_best_day': 'Лучший день',
    'mystats.wrapped_fastest': 'Быстрейшая победа',
    'mystats.wrapped_longest': 'Самая долгая победа',
    'mystats.records_title': 'Рекорды',
    'mystats.records_hint': 'Крайние значения за последние {n} игр.',
    'mystats.records_days': 'дн.',
    'mystats.records_games': 'игр',
    'mystats.records_break': 'Перерыв без игр',
    'mystats.records_max_day': 'Больше всего игр за день',
    'mystats.records_map_streak': 'Серия побед на карте',
    'mystats.records_best_series': 'Лучшая серия',
    'mystats.records_wins_in_row': 'побед подряд',
    'mystats.facts_title': 'Интересные факты',
    'mystats.facts_hint': 'Собрано из твоих игр — чем больше матчей, тем точнее.',
    'mystats.advice_title': 'Что можно улучшить',
    'mystats.advice_hint': 'Советы по твоей статистике. Это подсказки, а не приговор.',
    'mystats.races_title': 'Игры по расам',
    'mystats.places_title': 'Распределение мест',
    'mystats.maps_title': 'Карты',
    'mystats.map_col': 'Карта',
    'mystats.games_col': 'Игры',
    'mystats.winrate_col': 'Винрейт',
    'mystats.avg_place_col': 'Ср. место',
    'mystats.rivals_title': 'Соперники',
    'mystats.rival_col': 'Соперник',
    'mystats.recent_title': 'Последние игры',
    'mystats.all_games': 'Все игры →',
    'mystats.recent_place': '#{place} из {total}',
    'mystats.min': 'мин',
    'mystats.recent_form': 'Форма',
    'mystats.form_win': 'Победа',
    'mystats.form_loss': 'Поражение',
    'mystats.career': 'за карьеру',
    'mystats.no_data': 'Пока нет данных',
    'mystats.error': 'Не удалось загрузить личную статистику.',
    'mystats.unlinked_title': 'Игровой профиль не привязан',
    'mystats.unlinked': 'Эта страница показывает статистику твоего игрока. Попросите модератора привязать игровой профиль к аккаунту.',
    'mystats.unlinked_admin': 'У этого пользователя нет привязанного игрового профиля.',
    'mystats.open_profile': 'Открыть профиль',
    'mystats.open_card': 'Карточка игрока',
    'mystats.admin_view': 'Режим администратора: статистика игрока {name}.',
    'mystats.admin_view_generic': 'Режим администратора: у пользователя нет привязанного игрового профиля.',
    'mystats.admin_back': '← В админку',
    'mystats.day.1': 'Понедельник',
    'mystats.day.2': 'Вторник',
    'mystats.day.3': 'Среда',
    'mystats.day.4': 'Четверг',
    'mystats.day.5': 'Пятница',
    'mystats.day.6': 'Суббота',
    'mystats.day.7': 'Воскресенье',
    'mystats.fact.rank': 'Ты #{rank} из {total} в общем зачёте — топ {percent}%.',
    'mystats.fact.peak': 'Твой пик MMR — {elo}.',
    'mystats.fact.favorite_race': 'Чаще всего играешь за {race} — {games} игр с винрейтом {winrate}%.',
    'mystats.fact.best_map': 'Лучшая карта — {map}: {winrate}% побед за {games} игр.',
    'mystats.fact.most_played_map': 'Больше всего игр на карте {map} — {games}.',
    'mystats.fact.favorite_format': 'Любимый формат — {format}: {games} игр с винрейтом {winrate}%.',
    'mystats.fact.favorite_mod': 'Чаще всего играешь с модом {mod} — {games} игр.',
    'mystats.fact.best_day': 'Лучший день недели — {day}: {wins} побед за {games} игр.',
    'mystats.fact.fastest_win': 'Самая быстрая победа — за {minutes} мин.',
    'mystats.fact.longest_win': 'Самая долгая победа — {minutes} мин.',
    'mystats.fact.rival': 'Чаще всего пересекаешься с {name} — {games} совместных игр.',
    'mystats.fact.nemesis': 'Тяжелее всего против {name} — {winrate}% побед.',
    'mystats.fact.victim': 'Удобнее всего против {name} — {winrate}% побед.',
    'mystats.fact.best_streak': 'Лучшая серия — {n} побед подряд.',
    'mystats.fact.activity': 'Ты играл в {days} игровых дней.',
    'mystats.fact.avg_place': 'Средняя позиция — {place} из {scale}.',
    'mystats.fact.favorite_hour': 'Чаще всего играешь около {hour}:00 по Москве.',
    'mystats.fact.win_streak_now': 'Сейчас у тебя серия из {n} побед.',
    'mystats.fact.loss_streak_now': 'Сейчас серия из {n} поражений — не вешай нос.',
    'mystats.fact.sample': 'Детальная статистика — по последним {n} играм из {total}.',
    'mystats.advice.play_more': 'Сыграй ещё несколько игр — данных пока мало для точных выводов.',
    'mystats.advice.low_winrate': 'Винрейт {winrate}% — попробуй более безопасный старт: не гонись за лёгкими фрагами и следи за разведкой.',
    'mystats.advice.race_weak': 'За {race} винрейт всего {winrate}% за {games} игр. Возможно, стоит потренировать билды или сменить расу.',
    'mystats.advice.map_avoid': 'На карте {map} лишь {winrate}% побед за {games} игр — убери её из пула или разбери отдельно.',
    'mystats.advice.avg_place_high': 'Средняя позиция {place} — чаще доживай до финала: экономь армию и не открывайся на два фронта.',
    'mystats.advice.early_elim': 'В {percent}% игр ты выбываешь в нижней половине — пересмотри раннее развитие и разведку.',
    'mystats.advice.losing_streak': 'Серия из {n} поражений. Возьми паузу и начни следующую игру с разбора реплея.',
    'mystats.advice.winning_streak': 'Серия из {n} побед — не меняй то, что работает, и записывай удачные билды.',
    'mystats.advice.low_activity': 'За последние 30 дней всего {games} игр — активность на лидерборде просядет.',
    'mystats.advice.close_to_rank': 'До {rank}-го места всего {gap} MMR — одна хорошая игра может поднять тебя выше.',
    'mystats.advice.map_hidden_gem': 'На карте {map} у тебя {winrate}% побед, но всего {games} игр — выбирай её чаще.',
    'mystats.advice.balanced': 'Всё выглядит ровно: играй регулярно и пробуй новые карты, чтобы расти.',

    'players.me_suffix': ' (вы)',

    'support.button': 'Поддержать проект',
    'support.card_title': 'Номер карты (Сбер)',
    'support.copied': 'Скопировано!',
    'support.copy_manually_short': 'Скопируйте вручную',

    // Плашка и страница поддержки
    'support.topbar': 'Поддержать',
    'support.banner_text': 'Сайт некоммерческий, а времена тяжёлые — хостинг дорожает. Если можете, поддержите проект 🙏',
    'support.banner_cta': 'Поддержать',
    'support.banner_dismiss': 'Скрыть',
    'support.page_title': 'Поддержать проект',
    'support.page_intro': 'SC2 FFA League — некоммерческий проект. Я, nerdError, делаю его на чистом энтузиазме, без рекламы и платных подписок. Сейчас время непростое, и хостинг, на котором живёт сайт, постоянно дорожает.',
    'support.page_hosting': 'Хостинг сайта стоит 550 ₽ в месяц. Это основная и по сути единственная постоянная статья расходов — всё остальное я делаю бесплатно.',
    'support.methods_title': 'Способы поддержки',
    'support.method_card_title': 'Перевод на карту (Сбер)',
    'support.method_card_desc': 'Прямой перевод на карту Сбербанка. Подойдёт любая сумма — даже небольшая помощь ощутима.',
    'support.method_card_copy': 'Скопировать номер карты',
    'support.method_da_title': 'DonationAlerts',
    'support.method_da_desc': 'Сервис поддерживает иностранные платежи — можно поддержать проект из-за рубежа.',
    'support.method_da_button': 'Открыть DonationAlerts',
    'support.thanks': 'Спасибо за любую поддержку! Даже доброе слово или репост очень помогают проекту.',
    'support.back': '← Назад',
    'support.donations_title': 'Спасибо тем, кто уже поддержал',

    'games.team_label': 'Команда',
    'games.error_need_two_teams': 'Для командного формата нужно минимум две команды',
    'games.error_multiple_winner_teams': 'Победителями может быть только одна команда',
    'games.error_incomplete_winner_team': 'Все игроки команды-победителя должны быть отмечены',

    'games.is_team_label': 'Командная игра',
    'games.team_size_label': 'Размер команды',
    'games.team_count_label': 'Количество команд',
    'games.error_team_size_mismatch': 'Количество игроков должно делиться на размер команды ({size})',
    'games.error_teams_uneven': 'Все команды должны быть одинакового размера ({size})',
    'games.error_teams_incomplete': 'Заполните все слоты: {teams} команд(ы) по {size} игроков.',
    'games.distribute_teams': "Распределить по командам",
    'games.team_short': 'Команда',

    'games.clear_form': 'Очистить',
    'games.clear_form_confirm': 'Очистить форму и не использовать настройки последней игры?',
    "games.use_last_game": "Копировать предыдущие настройки",

    'games.track_elim_label': 'Учитывать порядок выбывания',
    'games.new_player': 'Новый',
    'games.new_player_prompt': 'Имя нового игрока:',
    'games.new_player_error': 'Не удалось создать игрока: ',
    'games.match_add_forbidden': 'Недостаточно прав для добавления игры.',
    'games.not_eliminated': 'Не выбыл',
    'games.used': 'занято',
    'games.from_replay': 'Из реплея',
    'games.replay_drop_hint': 'Перетащите файл реплея (.SC2Replay) в любое место раздела',
    'games.replay_dropzone': 'Отпустите файл реплея',
    'games.replay_dropzone_hint': 'Форма игры заполнится автоматически (.SC2Replay)',
    'games.replay_parsing': 'Разбор реплея…',
    'games.replay_parse_error': 'Не удалось разобрать реплей: ',
    'games.replay_not_replay': 'Выберите файл реплея StarCraft II (.SC2Replay)',
    'games.replay_too_large': 'Файл реплея слишком большой (максимум 25 МБ)',
    'games.replay_prefilled': 'Форма заполнена из реплея. Проверьте данные перед сохранением.',
    'games.replay_player_unmatched': 'Игрок не найден в базе — выберите или создайте',
    'games.replay_unresolved': 'Не сопоставлены игроки из реплея: {names}',
    'games.replays_button': 'Папка реплеев',
    'games.replays_title': 'Последние реплеи',
    'games.replays_hint': 'Реплеи из папки, свежие сверху. Нажмите на любой — форма игры заполнится автоматически.',
    'games.replays_parsing': 'Разбор реплеев: {done} из {total}…',
    'games.replays_done': 'Показаны {n} из {total} реплеев',
    'games.replays_empty': 'В папке не найдено реплеев .SC2Replay',
    'games.replays_close': 'Скрыть список',
    'games.replays_duration': '{n} мин',
    'games.replays_players': 'игроков: {n}',
    'games.replays_map_missing': 'карта не найдена в справочнике',
    'games.replays_add': 'Добавить игру',
    'games.replays_more': 'Показать ещё реплеи',
    'games.replays_change': 'Сменить папку',
    'games.replays_reset': 'Сбросить папку',
    'games.replays_restore_hint': 'Папка реплеев сохранена. Нажмите «Папка реплеев», чтобы подгрузить реплеи.',
    'games.replays_cached': 'из кэша',
    'games.replay_score_hint': 'Общий счёт: {score} (добыто {gathered} + уничтожено {killed} + потеряно {lost} + живые {army}). Продержался: {survived}. Список отсортирован по счёту.',
    'games.replay_complete': 'Реплей полный: игра доиграна до конца.',
    'games.replay_complete_places': 'Реплей полный: игра доиграна до конца. Места расставлены по общему счёту — проверьте перед сохранением.',
    'games.replay_incomplete_no_winner': 'В реплее нет явного победителя — матч мог быть прерван. Проверьте победителя и места вручную.',
    'games.replay_incomplete_truncated': 'Данные реплея обрываются за {gap} до конца игры — счёт и выбывание могут быть неполными.',
    'games.replay_score_close': 'Счёт соседних по местам игроков почти равен (разница {gap}) — погрешность оценки ±2%, места могли сместиться, проверьте вручную.',
    'games.replay_host_matched': 'Проводящий определён по наблюдателю из реплея: {name}.',
    'games.replay_host_candidates': 'Проводящий не определён. Наблюдатели в реплее: {names} — выберите ведущего вручную.',
    'games.replay_duplicate': 'Реплей уже был добавлен в игру от {date}.',
    'games.replay_duplicate_no_date': 'Реплей уже был добавлен в игру.',
    'games.replay_duplicate_open': 'Открыть игру',
    'games.replays_duplicate': 'игра уже добавлена: {date}',
    'games.replays_duplicate_no_date': 'игра уже добавлена',

    'leaderboard.activity': 'Активность',
    'leaderboard.avg_place': 'Ср. место',
    'leaderboard.help_title': 'Как считается рейтинг',
    'leaderboard.help_intro': 'Мы поощряем активных игроков и тех, кто старается продержаться в игре как можно дольше. Проигрывать — не страшно. Главное — играть.',
    'leaderboard.help_activity': 'Очки активности начисляются за каждую игру. Чем больше вы играете, тем выше ваш рейтинг.',
    'leaderboard.help_place': 'За хорошее место в игре дают больше очков, за плохое — меньше.',
    'leaderboard.help_not_elim': 'Если вы дожили до конца, но не победили — вы получаете почти максимум очков.',
    'leaderboard.help_winner': 'Победа приносит самые высокие очки.',
    'leaderboard.help_early': 'Очень ранний вылет даёт минимум очков, но всё равно начисляет базу — рейтинг не уходит в минус.',
    'leaderboard.help_days': 'Игра в разные дни дополнительно поощряется',
    'leaderboard.help_quality': '«Качество» — это среднее число очков активности за одну игру. Он показывает, насколько результативно вы проводите каждую отдельную игру.',
    'leaderboard.help_provisional': 'MMR — это оценка силы с учётом недоигранности. Пока у игрока мало игр, рейтинг считается осторожно: он тянется к стартовым 1500 и снижается за «неуверенность» в результате. Поэтому одна-две удачные игры не поднимают в топ над опытными игроками — рейтинг растёт и «крепнет» по мере накопления игр.',
    'leaderboard.breakdown_title': 'Вклад в MMR по местам',
    'leaderboard.breakdown_top': '#1–2',
    'leaderboard.breakdown_mid': '#3–6',
    'leaderboard.breakdown_bottom': '#7+',
    'leaderboard.breakdown_unknown': 'Без места',
    'leaderboard.breakdown_total': 'Итого в сырой MMR',

    'leaderboard.explain_title': 'Как считается MMR',
    'leaderboard.explain_button': 'Как работает MMR?',
    'leaderboard.explain_intro': 'MMR стартует с 1500 и меняется после каждой игры. Важен не сам факт победы, а результат относительно ожиданий: место в лобби, рейтинги соперников и формат игры.',
    'leaderboard.explain_how_title': 'Как это работает — простыми словами',
    'leaderboard.explain_how_1': 'MMR сравнивает ваш результат с ожидаемым. Выступили лучше ожидаемого — рейтинг растёт, хуже — падает. Важен не сам факт победы, а то, насколько хорошо вы сыграли относительно соперников.',
    'leaderboard.explain_how_2': 'Ожидание зависит от силы соперников. Проиграть сильному «не стыдно» — теряете мало; проиграть слабому дорого. Победа над слабым даёт немного, над сильным — много.',
    'leaderboard.explain_how_3': 'В FFA важен и результат по месту: дожить до конца без победы почти так же ценно, как победить (победа — максимум), а ранний вылет стоит дорого.',
    'leaderboard.explain_how_4': 'Размер лобби усиливает эффект: в большой игре каждый результат весит больше (множитель N − 1), ведь вы обыграли или уступили большему числу людей.',
    'leaderboard.explain_how_5': 'Шаг за одну игру ограничен ±50: ни одна игра не обрушит и не вознесёт рейтинг, он меняется постепенно — по серии матчей.',
    'leaderboard.explain_how_6': 'Поправка за недоигранность: пока игр мало, рейтинг «осторожный» — он ближе к 1500 и снижен на величину неопределённости, чтобы случайная удача не выносила в топ. С числом игр рейтинг «отвердевает».',
    'leaderboard.explain_formula_title': 'Формула',
    'leaderboard.explain_e': 'Ожидание по каждому сопернику: E = 1 / (1 + 10^((R_соперник − R_вы) / 400)), затем усредняется по всем соперникам в игре.',
    'leaderboard.explain_delta': 'Изменение: Δ = K · (N − 1) · (S − E) · вес_формата, где K = 32, N — число игроков, а шаг за одну игру ограничен ±50.',
    'leaderboard.explain_s': 'Результат S считается по месту: победа = 1.0; дожитие до конца без победы ≈ (N − 2) / (N − 1); выбывание = (N − place) / (N − 1).',
    'leaderboard.explain_confidence': 'После пересчёта применяется «осторожная» поправка за недоигранность: при малом числе игр рейтинг тянется к 1500 и дополнительно снижается на величину неопределённости. Поэтому одна-две игры не поднимают в топ.',
    'leaderboard.explain_example_title': 'Пример: Emperror vs Seigneur',
    'leaderboard.explain_example_intro': 'Оба примерно равны по сырому рейтингу, но у Emperror он чуть выше, и он сыграл больше игр — в итоге он выше на 25 MMR.',
    'leaderboard.explain_row_games': 'Игры',
    'leaderboard.explain_row_firsts': 'Побед (1-е место)',
    'leaderboard.explain_row_raw': 'Сырой MMR',
    'leaderboard.explain_row_mmr': 'Итоговый MMR',
    'leaderboard.explain_buckets_note': 'Вклад в сырой MMR по занятым местам:',
    'leaderboard.explain_place_col': 'Место',
    'leaderboard.explain_delta_col': 'Δ MMR',
    'leaderboard.explain_games_col': 'Игр',
    'leaderboard.explain_conclusion': 'Ключ — середина. Seigneur теряет в среднем около 16 MMR за каждую игру на 3–6 месте: его рейтинг высок, ожидания выше, и такие места их не оправдывают. У Emperror середина примерно в нуле. Победы дают обоим близкий плюс, но именно средние места определяют разницу. Итоговые 25 MMR разницы с поправкой на объём игр — фактически «в пределах шума».',
    'leaderboard.explain_reading_title': 'Как читать рейтинг',
    'leaderboard.explain_reading': 'Смотрите не только на итоговый MMR, но и на число игр: у игрока с 30+ матчами рейтинг устойчив, у новичка — предварительный. В раскрытии строки видно, за счёт чего он складывается (вклад мест 1–2, 3–6 и 7+). Самый прочный рейтинг — у тех, кто стабильно берёт высокие места и не проваливается глубоко.',
    'leaderboard.expand_hint': 'Нажмите на строку, чтобы открыть график прогресса',
    'leaderboard.open_my_chart': 'Открыть график игрока в рейтинге',
    'leaderboard.chart_title': 'Прогресс игрока',
    'leaderboard.chart_hint': 'Динамика MMR, места в рейтинге, активности, игр и побед за последние сыгранные игры.',
    'leaderboard.chart_elo': 'MMR',
    'leaderboard.chart_rank': 'Место в рейтинге',
    'leaderboard.chart_games': 'Игры',
    'leaderboard.chart_wins': 'Победы',
    'leaderboard.chart_empty': 'У игрока пока нет сыгранных игр',
    'leaderboard.chart_error': 'Не удалось загрузить историю игр',
    'leaderboard.chart_toggle': 'Включить / выключить линию',
    'leaderboard.chart_win': 'Победа',
    'leaderboard.chart_place': 'Место',
    'leaderboard.chart_team': 'команда',
    'leaderboard.help_outro': 'Проигрывать — не страшно. Главное — играть.',

    'leaderboard.mode_all': 'Все',
    'leaderboard.team_view_players': 'Личный зачёт',
    'leaderboard.team_view_pairs': 'Связки',
    'leaderboard.pair_col': 'Связка',
    'leaderboard.pair_elo': 'MMR связки',
    'leaderboard.pair_elo_hint': 'Отдельный рейтинг пары: считается только по их совместным играм',
    'leaderboard.pair_sum': 'Сумма MMR',
    'leaderboard.pair_together': 'Вместе',
    'leaderboard.pair_empty': 'Пока нет командных игр, где игроки были в одной команде',
    'leaderboard.pair_chart_title': 'Прогресс связки',
    'leaderboard.pair_chart_empty': 'У связки пока нет совместных игр',
    'leaderboard.pair_help_title': 'Как считается зачёт связок',
    'leaderboard.pair_help_intro': 'В этом зачёте игроки объединяются в связки по два — только если они действительно играли в одной команде.',
    'leaderboard.pair_help_sum': '«MMR связки» — отдельный рейтинг пары. Он считается только по их совместным играм по тем же правилам Elo, что и личный MMR, и не является суммой личных рейтингов игроков.',
    'leaderboard.pair_help_together': 'Пара начинает с 1500 и меняется за результат команды: победа поднимает рейтинг, поражение опускает. Чем больше совместных игр, тем точнее MMR связки.',
    'leaderboard.pair_help_games': 'Игры, победы, винрейт и среднее место считаются только по матчам, где оба игрока были в одной команде.',
    'leaderboard.pair_help_outro': 'Связка появляется в таблице с первой совместной игры; чем больше игр — тем надёжнее её показатели.',
'leaderboard.pair_days': 'Игровых дней',
'leaderboard.season_pair_help_rank': 'В сезонном зачёте связки ранжируются по победам, затем по меньшему числу игр и среднему месту.',
'leaderboard.season_pair_help_days': '«Игровых дней» — количество дней сезона, в которые связка играла вместе.',
    'leaderboard.filter_30d': 'Последние 30 дней',
    'leaderboard.mode_solo': 'FFA',
    'leaderboard.mode_team': 'Командные FFA',
    'leaderboard.mode_league_s3': 'FFA Лига (3 сезон)',
    'leaderboard.mode_team_s1': '2x2 FFA Лига (1 сезон)',
    'leaderboard.season_help_title': 'Сезонный зачёт',
    'leaderboard.season_help_text': 'Учитываются только игры этого формата, сыгранные с сентября 2026 года по конец 2026 года. Основной параметр — число побед.',
    'leaderboard.days': 'Дней',
    'leaderboard.quality': 'Качество',
    'leaderboard.rank_up': 'Выше на {n}',
    'leaderboard.rank_down': 'Ниже на {n}',
    'leaderboard.rank_prev': 'В прошлый игровой день — {n}-е место',
    'leaderboard.rank_new': 'Новый в рейтинге',
    'leaderboard.rank_new_short': 'нов',
    'leaderboard.rank_held': '{n} дн.',
    'leaderboard.rank_held_today': 'сегодня',
    'leaderboard.rank_held_title': 'Держится на этом месте {n} дн.',
    'leaderboard.rank_reign': '{n} дн. на троне',
    'leaderboard.rank_reign_today': 'взял трон сегодня',
    'leaderboard.rank_reign_title': 'Держит первое место {n} дн.',
    'leaderboard.aka_hint': 'Показать все aka',
    'leaderboard.aka_collapse': 'Свернуть aka',

    // «Зал славы» недели над таблицей рейтинга
    'leaderboard.hof_title': 'Зал славы',
    'leaderboard.hof_period_week': 'Неделя',
    'leaderboard.hof_period_month': 'Месяц',
    'leaderboard.hof_period_year': 'Год',
    'leaderboard.hof_period': '{from} — {to} · игр: {n}',
    'leaderboard.hof_games': 'игр: {n}',
    'leaderboard.hof_opponents': 'ср. MMR соперников: {n}',
    'leaderboard.hof_minutes': '{n} мин',
    'leaderboard.hof_wins_n': 'побед: {n}',
    'leaderboard.hof_empty': 'За этот период игр ещё нет',
    'leaderboard.hof_wins': 'Победы',
    'leaderboard.hof_wins_hint': 'Больше всего побед за неделю',
    'leaderboard.hof_activity': 'Активность',
    'leaderboard.hof_activity_hint': 'Сумма очков активности за неделю',
    'leaderboard.hof_climb': 'Рывок в рейтинге',
    'leaderboard.hof_climb_hint': 'Наибольший подъём по MMR за неделю: место в рейтинге по MMR до и после',
    'leaderboard.hof_mmr': 'Прирост MMR',
    'leaderboard.hof_mmr_hint': 'Наибольший чистый прирост рейтинга за неделю (сумма изменений MMR)',
    'leaderboard.hof_streak': 'Серия побед',
    'leaderboard.hof_streak_hint': 'Самая длинная серия побед подряд за неделю',
    'leaderboard.hof_place': 'Средняя позиция',
    'leaderboard.hof_place_hint': 'Лучшая средняя итоговая позиция за неделю (минимум 3 игры)',
    'leaderboard.hof_days': 'Игровые дни',
    'leaderboard.hof_days_hint': 'Сколько дней из недели игрок заходил в игру',
    'leaderboard.hof_maps': 'Универсал',
    'leaderboard.hof_maps_hint': 'Больше всего разных карт за неделю',
    'leaderboard.hof_upset': 'Гроза авторитетов',
    'leaderboard.hof_upset_hint': 'Больше всего побед над соперниками, чей средний MMR выше своего',
    'leaderboard.hof_podium': 'Подиум',
    'leaderboard.hof_podium_hint': 'Больше всего попаданий в топ-3 по итоговому месту',
    'leaderboard.hof_stability': 'Стабильность',
    'leaderboard.hof_stability_hint': 'Самое ровное место по итогам игр: минимальный разброс позиций (минимум 3 игры)',
    'leaderboard.hof_rookie': 'Дебютант недели',
    'leaderboard.hof_rookie_hint': 'Лучший результат среди тех, кто провёл свои первые игры в лиге',
    'leaderboard.hof_sprinter': 'Спринтер',
    'leaderboard.hof_sprinter_hint': 'Самая быстрая победа за неделю',
    'leaderboard.hof_siege': 'Осадный',
    'leaderboard.hof_siege_hint': 'Самая долгая победа за неделю',
    'leaderboard.hof_daywins': 'Победы за день',
    'leaderboard.hof_daywins_hint': 'Больше всего побед за один игровой день',
    'leaderboard.hof_rivals': 'Кровные враги',
    'leaderboard.hof_rivals_hint': 'Пары игроков, которые чаще всех играли друг с другом',
    'leaderboard.hof_second': 'Вечно второй',
    'leaderboard.hof_second_hint': 'Больше всего вторых мест без единой победы',
    'leaderboard.hof_chill': 'Спад активности',
    'leaderboard.hof_chill_hint': 'У кого активность за неделю упала сильнее всего по сравнению с прошлой неделей',

    'statistics.title': 'Статистика',
    'statistics.summary_games': 'игр сыграно',
    'statistics.summary_players': 'игроков в лиге',
    'statistics.summary_maps': 'карт в игре',
    'statistics.summary_avg_players': 'ср. игроков в лобби',
    'statistics.summary_hours': 'часов в игре',
    'statistics.games_title': 'Игры по расам',
    'statistics.games_desc': 'Винрейт расы — кольцом, ниже — как раса выглядит по среднему месту, активности и числу игроков. Полосы сравнивают расы между собой, цифры — для точности.',
    'statistics.style_title': 'Средние оценки стиля по расам',
    'statistics.style_desc': 'Средний стиль игры расы по шести осям: адаптивность, агрессия, «черепаха», разнообразие, выживание и жадность. Чем дальше точка от центра, тем сильнее выражен признак.',
    'statistics.col_race': 'Раса',
    'statistics.col_ratings': 'Оценок',
    'statistics.col_players': 'Игроков',
    'statistics.maps_title': 'Статистика по картам',
    'statistics.mods_title': 'Статистика по модам',
    'statistics.hosts_title': 'Статистика по ведущим',
    'statistics.col_name': 'Название',
    'statistics.col_avg_players': 'Ср. игроков',
    'statistics.col_avg_duration': 'Ср. длит.',
    'statistics.col_last_game': 'Последняя игра',
    'statistics.show_all': 'Показать все',
    'statistics.hide_all': 'Скрыть',
    'statistics.empty': 'Пока нет данных',
    'statistics.mode_all': 'За всё время',
    'statistics.mode_now': 'Сейчас',
    'statistics.balance_title': 'Баланс рас',
    'statistics.balance_desc': 'Индекс силы считается по всем играм расы: победы (относительно ожидаемых с учётом числа игроков), места (включая финиши в топ-2) и активность. Итог нормируется к среднему по полю и усиливается для наглядности: 1.00 — средний уровень, выше — раса сильнее, ниже — слабее.',
    'statistics.balance_desc_now': 'Тот же индекс силы, но по последним ~60 играм — так видна текущая форма расы (а не среднее за всю историю). 1.00 — средний уровень поля, выше — раса сильнее сейчас, ниже — слабее.',
    'statistics.balance_most_imba': 'Самая имбовая',
    'statistics.balance_least_imba': 'Самая слабая',
    'statistics.balance_balanced': 'средний уровень',
    'statistics.balance_weak_side': '← слабее',
    'statistics.balance_imba_side': 'сильнее →',
    'statistics.mmr_title': 'ММР рас',
    'statistics.mmr_desc': 'Условный рейтинг каждой расы во времени. В каждой игре раса прибавляет или теряет очки в зависимости от того, выступили ли её игроки лучше или хуже среднего по полю (с учётом занятых мест). Линии показывают, как менялась сила расы от матча к матчу; 1500 — точка отсчёта.',
    'statistics.power_title': 'Имба рас во времени',
    'statistics.power_desc': 'Тот же индекс силы, что и в «Балансе рас», но показанный во времени: каждая точка считается по всем играм до этого момента, поэтому правая точка графика совпадает с балансом «за всё время». Пунктир 1.00 — средний уровень поля: выше — раса имбовее, ниже — слабее.',
    'statistics.power_desc_now': 'Тот же индекс силы, но по скользящему окну из последних ~60 игр (с текущей формой). Правая точка совпадает с балансом «сейчас». Пунктир 1.00 — средний уровень поля: выше — раса имбовее, ниже — слабее.',
    'statistics.monthly_games_title': 'Игр по месяцам',
    'statistics.monthly_games_desc': 'Число сыгранных игр в каждом месяце.',
    'statistics.race_players_title': 'Игроки рас по месяцам',
    'statistics.race_players_desc': 'Сколько уникальных игроков каждой расы играло в лиге за месяц.',
    'statistics.players_count_title': 'Винрейт по числу игроков',
    'statistics.players_count_desc': 'Доля побед расы в лобби на 4, 5, 6 и более игроков (мелким шрифтом под процентом — число игр). Видно, какой расе лучше в больших лобби, а какой — в малых. Полупрозрачные ячейки — меньше 5 игр, там разброс случайный.',
    'statistics.lobby_race_title': 'Своя раса в лобби',
    'statistics.lobby_race_desc': 'Винрейт расы в зависимости от того, сколько её игроков собралось в одной игре: один, двое или трое и больше. Показывает, помогает ли расе численность или она чаще мешает.',
    'statistics.lobby_bucket_1': '1 в лобби',
    'statistics.lobby_bucket_2': '2 в лобби',
    'statistics.lobby_bucket_3': '3+ в лобби',
    'statistics.places_title': 'Распределение мест',
    'statistics.places_desc': 'Какая доля игр расы закончилась на каждом месте (в процентах от всех игр расы). В отличие от среднего места, показывает полную картину: пара побед и много последних мест или ровные финиши в середине.',
    'statistics.col_place': 'Место',
    'statistics.first_elim_title': 'Выбывания по расам',
    'statistics.first_elim_desc': 'Как часто раса выбывает самой первой и как часто доживает до финала (второе место). Учитываются игры, где известен порядок выбывания.',
    'statistics.first_elim_first': 'выбывает первым',
    'statistics.first_elim_last': 'доживает до финала',
    'statistics.col_favorite_win': 'Победы фаворита',
    'statistics.heatmap_title': 'Когда играют',
    'statistics.heatmap_desc': 'Число сыгранных игр по дням недели и часам (МСК). Ось часов начинается с 12:00, поэтому 00 — в середине, а вечер и ночь идут подряд. Ярче — больше игр в этот час: видно, когда проще всего собрать лобби.',
    'statistics.heatmap_less': 'меньше',
    'statistics.heatmap_more': 'больше',

    'games.now': 'Сейчас',

    'games.show_all_players': 'Показать всех',
    'games.no_winner': 'Нет победителя',
    'games.teams_short': 'команд',
    'games.hide_all_players': 'Скрыть всех',
    'games.place_1': '1-е место',
    'games.overlay_show': 'В оверлей OBS',
    'games.overlay_show_hint': 'Показать превью игры в OBS-оверлее на 15 секунд (ссылка оверлея — в «Режиме стримера»).',
    'games.overlay_show_done': '✓',
    'overlay.game_title': 'Игра',
    'overlay.status_connected': 'Оверлей подключён',
    'overlay.status_connecting': 'Нет связи с сервером — переподключаюсь…',
    'overlay.status_card_error': 'Не удалось загрузить карточку — повторяю…',
    'overlay.status_bad_token': 'Токен оверлея недействителен. Перевыпустите его в «Режиме стримера» и обновите ссылку в OBS.',
    'overlay.status_no_token': 'В ссылке оверлея нет токена. Скопируйте ссылку из «Режима стримера».',

    // Плашка «Сейчас в эфире» (live-стримы)
    'streams.banner_label': 'Сейчас в эфире:',
    'streams.viewers': '{n} зр.',
    'streams.banner_close': 'Скрыть',
    'streams.ffa_candidate': 'Потенциальные FFA',

    // Стримеры (админка)
    'admin.streamers_title': 'Стримеры',
    'admin.add_streamer': '+ Добавить стримера',
    'admin.streamers_hint': 'Ссылки на Twitch-каналы стримеров FFA. Сайт сам проверяет, кто сейчас в эфире, и показывает плашку сверху страницы.',
    'admin.streamers_empty': 'Стримеры пока не добавлены.',
    'admin.new_streamer_prompt': 'Ссылка на канал стримера (например, https://twitch.tv/nickname):',
    'admin.new_streamer_name_prompt': 'Отображаемое имя стримера:',
    'admin.streamer_name_required': 'Укажите имя стримера',
    'admin.delete_streamer_confirm': 'Удалить стримера "{name}"?',
    'admin.streamer_url_placeholder': 'https://twitch.tv/…',
    'admin.streamer_name_placeholder': 'Имя стримера',
    'admin.streamer_test': 'Тест',
    'admin.streamer_test_title': 'Показывать стрим в плашке всегда — чтобы проверить, как она выглядит (не зависит от Twitch)',
    'admin.streamer_player_placeholder': 'Игрок (не привязан)',
    'admin.streamer_player_hint': 'Привязка к профилю игрока: в его карточке появится раздел «Ссылки». Очистите поле, чтобы отвязать.',
    'admin.streamer_save_error': 'Не удалось сохранить стримера: ',
    'admin.streamer_delete_error': 'Не удалось удалить стримера: ',

    'log.action.streamer_create': 'Добавлен стример',
    'log.action.streamer_update': 'Изменён стример',
    'log.action.streamer_delete': 'Удалён стример',

    // Донаты (админка)
    'admin.donations_title': 'Донаты',
    'admin.donations_hint': 'Полученные донаты. Показываются списком внизу страницы «Поддержать проект».',
    'admin.donations_empty': 'Донаты пока не добавлены.',
    'admin.add_donation': '+ Добавить донат',
    'admin.donation_name_placeholder': 'Имя',
    'admin.donation_amount_placeholder': 'Сумма',
    'admin.donation_message_placeholder': 'Сообщение (необязательно)',
    'admin.donation_required': 'Укажите имя и положительную сумму',
    'admin.donation_save_error': 'Не удалось сохранить донат: ',
    'admin.donation_delete_error': 'Не удалось удалить донат: ',
    'admin.delete_donation_confirm': 'Удалить донат от "{name}"?',

    'log.action.donation_create': 'Добавлен донат',
    'log.action.donation_update': 'Изменён донат',
    'log.action.donation_delete': 'Удалён донат',

    // Вовлечение
    'recap.title': 'С прошлого визита',
    'recap.subtitle': 'Пока вас не было:',
    'recap.games': 'Новых игр',
    'recap.players': 'Игроков в них',
    'recap.your_games': 'Ваши игры (победы/игры)',
    'recap.mmr': 'MMR за это время',
    'recap.rank': 'Место в рейтинге',
    'recap.notifications': 'Непрочитанных уведомлений',
    'recap.followers': 'Новых подписчиков',
    'recap.last_game': 'Последняя игра',
    'recap.react_title': 'Игры, где вы ещё не голосовали',
    'recap.react_hint': 'Реакции и «кто запомнился» — в один клик',
    'recap.empty': 'Пока ничего нового — но это легко исправить.',
    'recap.open_games': 'Смотреть игры',
    'recap.dismiss': 'Понятно',
    'recap.test': 'Показать «пока вас не было» (тест)',

    'follow.button': 'Подписаться',
    'follow.following': 'Вы подписаны',
    'follow.count': '{n} подписчиков',
    'follow.login': 'Войдите, чтобы подписаться',
    'follow.hint': 'Уведомим о победах игрока и его стримах',
    'follow.error': 'Не удалось изменить подписку',
    'follow.unavailable': 'Недоступно',

    'share.button': 'Поделиться',
    'share.download_hint': 'Скачать картинку PNG',
    'share.player_title': 'SC2 FFA League · игрок',
    'share.game_title': 'SC2 FFA League · игра',
    'share.game_subtitle': 'Итоги игры',
    'share.downloaded': 'Картинка сохранена',
    'share.error': 'Не удалось поделиться',


    'reactions.title': 'Реакции',
    'reactions.fire': 'Зрелищно',
    'reactions.clutch': 'Клатч',
    'reactions.brain': 'Макро',
    'reactions.lucky': 'Повезло',
    'reactions.throw': 'Слив',
    'reactions.boring': 'Скучно',
    'reactions.mvp': 'Больше всего запомнился',
    'reactions.mvp_short': 'Запомнился',
    'reactions.mvp_hint': 'Кто больше всего запомнился в этой игре?',
    'reactions.login': 'Войдите, чтобы голосовать',
    'reactions.votes': '{n} голосов',
    'reactions.you': 'ваш голос',
    'reactions.error': 'Не удалось сохранить реакцию',
    'reactions.unavailable': 'Реакции пока недоступны',
    'reactions.todo': '🔥 вы ещё не оценили эту игру',

    'player.reactions_title': 'Отношение к игроку',
    'player.reactions_card_title': 'Отношение',
    'player.reactions_total': 'Всего реакций: {n}',
    'player.reactions_hint': 'Жми на всё, что подходит — можно несколько',
    'player.reactions_login': 'Войдите, чтобы реагировать',
    'player.reactions_verdict': 'Лига считает',
    'player.reactions_error': 'Не удалось сохранить реакцию',
    'player.reaction.love': 'Люблю его',
    'player.reaction.respect': 'Уважаю',
    'player.reaction.friend': 'Свой человек',
    'player.reaction.teacher': 'Учит играть',
    'player.reaction.funny': 'Веселит',
    'player.reaction.danger': 'Опасный соперник',
    'player.reaction.chaos': 'Непредсказуемый',
    'player.reaction.lucky': 'Везунчик',
    'player.reaction.annoy': 'Бесит',
    'player.reaction.throw': 'Сливает',
    'player.reaction.turtle': 'Тянет игру',
    'player.reaction.toxic': 'Токсик',

    'challenge.title': 'Челлендж недели',
    'challenge.days_left': 'Осталось {n} дн.',
    'challenge.progress': '{current} из {target}',
    'challenge.done': 'Выполнено!',
    'challenge.login': 'Войдите, чтобы видеть прогресс',
    'challenge.unlinked': 'Привяжите игровой профиль, чтобы видеть прогресс',
    'challenge.wins': 'Выиграйте {n} игры за неделю',
    'challenge.games': 'Сыграйте {n} игры за неделю',
    'challenge.map_win': 'Победите на карте «{map}»',
    'challenge.race_win': 'Выиграйте {n} игры за {race}',
    'challenge.top2': 'Войдите в топ-2 {n} раза',
    'challenge.unique_maps': 'Сыграйте на {n} разных картах',
    'challenge.streak': 'Выиграйте {n} игры подряд',
    'challenge.open': 'Моя статистика',

    'notif.follow_win': '{name} победил',
    'notif.streamer_live': '{name} в эфире',
    'notif.open_stream': 'Смотреть',

    // Загрузка
    'loading.text': 'ЗАГРУЗКА…',
};
